import { pickDomAttributes, mediaQueries } from '@bgea-js/react-utilities';
import { Card, Icon, Content as Content$1, Notification, Button as Button$1, Container, Columns, Navbar, Tabs as Tabs$1, Heading, Block as Block$1, Footer as Footer$1, Hero, Breadcrumb } from '@bgea-js/react-ui';
import ReactCollapsible from 'react-collapsible';
import { ChevronRightIcon, ChevronDownIcon, BgeaNewIcon, BgeaIcon, FacebookIcon } from '@bgea-js/react-icons';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';
import React, { useState, useEffect } from 'react';
import _styled from '@emotion/styled/base';
import * as colors from '@bgea-js/colors';
import PropTypes from 'prop-types';
import { useScript } from '@bgea-js/react-hooks';
import { slide } from 'react-burger-menu';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { createElement } from '@emotion/react';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var _excluded$o = ["title", "children", "footer"];
var Collapsible = function Collapsible(_ref) {
  var title = _ref.title,
    children = _ref.children,
    footer = _ref.footer,
    props = _objectWithoutProperties$1(_ref, _excluded$o);
  var domAttributes = pickDomAttributes(props);
  var trigger = jsxs(Card.Header, {
    children: [jsx(Card.Header.Title, {
      children: title
    }), jsx(Card.Header.Icon, {
      children: jsx(Icon, {
        children: jsx(ChevronRightIcon, {})
      })
    })]
  });
  var triggerWhenOpen = jsxs(Card.Header, {
    children: [jsx(Card.Header.Title, {
      children: title
    }), jsx(Card.Header.Icon, {
      children: jsx(Icon, {
        children: jsx(ChevronDownIcon, {})
      })
    })]
  });
  return jsx(Card, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: jsxs(ReactCollapsible, {
      trigger: trigger,
      triggerWhenOpen: triggerWhenOpen,
      open: false,
      tabIndex: 0,
      transitionTime: 100,
      children: [jsx(Card.Content, {
        children: jsx(Content$1, {
          children: children
        })
      }), jsx(Card.Footer, {
        children: footer
      })]
    })
  }));
};

var _excluded$n = ["children"];
var AlertBanner = function AlertBanner(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties$1(_ref, _excluded$n);
  var domAttributes = pickDomAttributes(props);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var closeNotification = function closeNotification() {
    setActive(false);
  };
  return jsx(Fragment, {
    children: active && jsxs(Notification, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
      children: [jsx(Button$1, {
        remove: true,
        onClick: function onClick() {
          return closeNotification();
        }
      }), jsx(Container, {
        children: children
      })]
    }))
  });
};

var Button = /*#__PURE__*/_styled(Button$1, process.env.NODE_ENV === "production" ? {
  target: "e1nk3q6w0"
} : {
  target: "e1nk3q6w0",
  label: "Button"
})("background:none;color:inherit;border-color:#dbdbdb;padding:calc(0.5em - 1px) 1em;font:inherit;cursor:pointer;outline:inherit;margin-bottom:2rem;display:block!important;font-weight:bold;background-color:", colors.whiteSmoke, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSTJDIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCdXR0b24gYXMgVUlCdXR0b24gfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11aSc7XG5pbXBvcnQgKiBhcyBjb2xvcnMgZnJvbSAnQGJnZWEtanMvY29sb3JzJztcblxuZXhwb3J0IGNvbnN0IEJ1dHRvbiA9IHN0eWxlZChVSUJ1dHRvbik8YW55PmBcbiAgYmFja2dyb3VuZDogbm9uZTtcbiAgY29sb3I6IGluaGVyaXQ7XG4gIGJvcmRlci1jb2xvcjogI2RiZGJkYjtcbiAgcGFkZGluZzogY2FsYygwLjVlbSAtIDFweCkgMWVtO1xuICBmb250OiBpbmhlcml0O1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIG91dGxpbmU6IGluaGVyaXQ7XG4gIG1hcmdpbi1ib3R0b206IDJyZW07XG4gIGRpc3BsYXk6IGJsb2NrICFpbXBvcnRhbnQ7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9ycy53aGl0ZVNtb2tlfTtcbmA7XG4iXX0= */"));

var _excluded$m = ["children", "collapseText", "expandText"];
var ButtonCollapsible = function ButtonCollapsible(_ref) {
  var children = _ref.children,
    collapseText = _ref.collapseText,
    expandText = _ref.expandText,
    props = _objectWithoutProperties$1(_ref, _excluded$m);
  var domAttributes = pickDomAttributes(props);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isReadMore = _useState2[0],
    setIsReadMore = _useState2[1];
  return jsxs(Fragment, {
    children: [jsx(Button, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
      onClick: function onClick() {
        return setIsReadMore(!isReadMore);
      },
      children: isReadMore ? collapseText : expandText
    })), isReadMore && jsx(Content$1, {
      children: children
    })]
  });
};

function ownKeys(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function _objectSpread2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ownKeys(Object(r), !0).forEach(function (t) {
      _defineProperty(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function _extends() {
  return (_extends = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }).apply(this, arguments);
}
function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && _setPrototypeOf(e, t);
}
function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}
function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};
  var r,
    i,
    n = {},
    s = Object.keys(e);
  for (i = 0; i < s.length; i++) r = s[i], t.indexOf(r) >= 0 || (n[r] = e[r]);
  return n;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var r,
    i,
    n = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (i = 0; i < s.length; i++) r = s[i], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _possibleConstructorReturn(e, t) {
  if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(e);
}
function _createSuper(e) {
  var t = _isNativeReflectConstruct();
  return function () {
    var r,
      i = _getPrototypeOf(e);
    if (t) {
      var n = _getPrototypeOf(this).constructor;
      r = Reflect.construct(i, arguments, n);
    } else r = i.apply(this, arguments);
    return _possibleConstructorReturn(this, r);
  };
}
function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}
function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e);
}
function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
  }
}
function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, i = new Array(t); r < t; r++) i[r] = e[r];
  return i;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function createCommonjsModule(e, t) {
  return t = {
    exports: {}
  }, e(t, t.exports), t.exports;
}
function emptyFunction() {}
function emptyFunctionWithReset() {}
function cn(e) {
  return e.map(function (e) {
    return !1 === e ? null : e;
  }).join(" ").replace(/\s+/g, " ").trim();
}
function slideSize(e, t) {
  return 100 / e * t / t;
}
function slideTraySize(e, t) {
  return 100 * e / t;
}
function pct(e) {
  return "".concat(e, "%");
}
function equal(e, t, r) {
  if (e === t) return !0;
  var i = types[jkrosoType(e)],
    n = types[jkrosoType(t)];
  return !(!i || i !== n) && i(e, t, r);
}
function memoGaurd(e) {
  return function (t, r, i) {
    if (!i) return e(t, r, []);
    for (var n, s = i.length; n = i[--s];) if (n[0] === t && n[1] === r) return !0;
    return e(t, r, i);
  };
}
function arrayEqual(e, t, r) {
  var i = e.length;
  if (i !== t.length) return !1;
  for (r.push([e, t]); i--;) if (!equal(e[i], t[i], r)) return !1;
  return !0;
}
function objectEqual(e, t, r) {
  if ("function" == typeof e.equal) return r.push([e, t]), e.equal(t, r);
  var i = getEnumerableProperties(e),
    n = getEnumerableProperties(t),
    s = i.length;
  if (s !== n.length) return !1;
  for (i.sort(), n.sort(); s--;) if (i[s] !== n[s]) return !1;
  for (r.push([e, t]), s = i.length; s--;) {
    var o = i[s];
    if (!equal(e[o], t[o], r)) return !1;
  }
  return !0;
}
function getEnumerableProperties(e) {
  var t = [];
  for (var r in e) "constructor" !== r && t.push(r);
  return t;
}
function isNonNullObject(e) {
  return !!e && "object" == _typeof(e);
}
function isSpecial(e) {
  var t = Object.prototype.toString.call(e);
  return "[object RegExp]" === t || "[object Date]" === t || isReactElement(e);
}
function isReactElement(e) {
  return e.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(e) {
  return Array.isArray(e) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(e, t) {
  return !1 !== t.clone && t.isMergeableObject(e) ? deepmerge(emptyTarget(e), e, t) : e;
}
function defaultArrayMerge(e, t, r) {
  return e.concat(t).map(function (e) {
    return cloneUnlessOtherwiseSpecified(e, r);
  });
}
function mergeObject(e, t, r) {
  var i = {};
  return r.isMergeableObject(e) && Object.keys(e).forEach(function (t) {
    i[t] = cloneUnlessOtherwiseSpecified(e[t], r);
  }), Object.keys(t).forEach(function (n) {
    r.isMergeableObject(t[n]) && e[n] ? i[n] = deepmerge(e[n], t[n], r) : i[n] = cloneUnlessOtherwiseSpecified(t[n], r);
  }), i;
}
function deepmerge(e, t, r) {
  (r = r || {}).arrayMerge = r.arrayMerge || defaultArrayMerge, r.isMergeableObject = r.isMergeableObject || isMergeableObject;
  var i = Array.isArray(t);
  return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : mergeObject(e, t, r) : cloneUnlessOtherwiseSpecified(t, r);
}
function WithStore(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {
      return {};
    },
    r = function (r) {
      function i(e, r) {
        var s;
        return _classCallCheck(this, i), s = n.call(this, e, r), s.state = t(_objectSpread2({}, r.state)), s.updateStateProps = s.updateStateProps.bind(_assertThisInitialized(s)), s;
      }
      _inherits(i, r);
      var n = _createSuper(i);
      return _createClass(i, [{
        key: "componentDidMount",
        value: function value() {
          this.context.subscribe(this.updateStateProps);
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value(e, t) {
          return !equals(t, this.state) || !equals(e, this.props);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.context.unsubscribe(this.updateStateProps);
        }
      }, {
        key: "updateStateProps",
        value: function value() {
          this.setState(t(_objectSpread2({}, this.context.state)));
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
            r = deepmerge_1(this.state, this.props);
          return /*#__PURE__*/React.createElement(e, _extends({
            ref: function ref(e) {
              t.instance = e;
            }
          }, r, {
            carouselStore: {
              getStoreState: this.context.getStoreState,
              masterSpinnerError: this.context.masterSpinnerError,
              masterSpinnerSuccess: this.context.masterSpinnerSuccess,
              setStoreState: this.context.setStoreState,
              subscribeMasterSpinner: this.context.subscribeMasterSpinner,
              unsubscribeAllMasterSpinner: this.context.unsubscribeAllMasterSpinner,
              unsubscribeMasterSpinner: this.context.unsubscribeMasterSpinner
            }
          }), this.props.children);
        }
      }]), i;
    }(React.Component);
  return _defineProperty(r, "contextType", Context), _defineProperty(r, "propTypes", {
    children: CarouselPropTypes.children
  }), _defineProperty(r, "defaultProps", {
    children: null
  }), r;
}
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
    function e(e, t, r, i, n, s) {
      if (s !== ReactPropTypesSecret_1) {
        var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw o.name = "Invariant Violation", o;
      }
    }
    function t() {
      return e;
    }
    e.isRequired = e;
    var r = {
      array: e,
      bigint: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    return r.PropTypes = r, r;
  },
  propTypes = createCommonjsModule(function (e) {
    e.exports = factoryWithThrowingShims();
  }),
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
  CarouselPropTypes = {
    children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
    direction: propTypes.oneOf(["forward", "backward"]),
    height: function height(e, t) {
      var r = e[t];
      return "vertical" !== e.orientation || null !== r && "number" == typeof r ? null : new Error("Missing required property '".concat(t, "' when orientation is vertical.  You must supply a number representing the height in pixels"));
    },
    orientation: propTypes.oneOf(["horizontal", "vertical"]),
    isBgImage: function isBgImage(e, t) {
      return !0 === e[t] && "img" === e.tag ? new Error("HTML img elements should not have a backgroundImage.  Please use ".concat(t, " for other block-level HTML tags, like div, a, section, etc...")) : null;
    }
  },
  boundedRange = function boundedRange(e) {
    var t = e.min,
      r = e.max,
      i = e.x;
    return Math.min(r, Math.max(t, i));
  },
  s = {
    buttonBack: "buttonBack___1mlaL"
  },
  _excluded$l = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "step", "totalSlides", "visibleSlides", "infinite"],
  ButtonBack = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.currentSlide,
          n = t.onClick,
          s = t.step,
          o = t.infinite,
          a = t.visibleSlides,
          l = t.totalSlides - a,
          c = Math.max(i - s, 0);
        o && (c = 0 === i ? l : c), r.setStoreState({
          currentSlide: c,
          isPlaying: !1
        }, null !== n && n.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          r = (e.carouselStore, e.className),
          i = (e.currentSlide, e.disabled, e.onClick, e.step, e.totalSlides, e.visibleSlides, e.infinite),
          n = _objectWithoutProperties(e, _excluded$l),
          o = cn([s.buttonBack, "carousel__back-button", r]),
          a = t.setDisabled(this.props.disabled, this.props.currentSlide, i);
        return /*#__PURE__*/React.createElement("button", _extends({
          type: "button",
          "aria-label": "previous",
          className: o,
          onClick: this.handleOnClick,
          disabled: a
        }, n), this.props.children);
      }
    }], [{
      key: "setDisabled",
      value: function value(e, t, r) {
        return null !== e ? e : 0 === t && !r;
      }
    }]), t;
  }(React.Component);
_defineProperty(ButtonBack, "propTypes", {
  carouselStore: propTypes.object.isRequired,
  children: CarouselPropTypes.children.isRequired,
  className: propTypes.string,
  currentSlide: propTypes.number.isRequired,
  disabled: propTypes.bool,
  onClick: propTypes.func,
  step: propTypes.number.isRequired,
  totalSlides: propTypes.number.isRequired,
  visibleSlides: propTypes.number.isRequired,
  infinite: propTypes.bool
}), _defineProperty(ButtonBack, "defaultProps", {
  className: null,
  disabled: null,
  onClick: null,
  infinite: !1
});
var jkrosoType = createCommonjsModule(function (e, t) {
    var r = {}.toString,
      i = "undefined" != typeof window ? window.Node : Function;
    e.exports = t = function t(e) {
      var t = _typeof(e);
      if ("object" != t) return t;
      if (t = n[r.call(e)], "object" == t) return e instanceof Map ? "map" : e instanceof Set ? "set" : "object";
      if (t) return t;
      if (e instanceof i) switch (e.nodeType) {
        case 1:
          return "element";
        case 3:
          return "text-node";
        case 9:
          return "document";
        case 11:
          return "document-fragment";
        default:
          return "dom-node";
      }
    };
    var n = t.types = {
      "[object Function]": "function",
      "[object Date]": "date",
      "[object RegExp]": "regexp",
      "[object Arguments]": "arguments",
      "[object Array]": "array",
      "[object Set]": "set",
      "[object String]": "string",
      "[object Null]": "null",
      "[object Undefined]": "undefined",
      "[object Number]": "number",
      "[object Boolean]": "boolean",
      "[object Object]": "object",
      "[object Map]": "map",
      "[object Text]": "text-node",
      "[object Uint8Array]": "bit-array",
      "[object Uint16Array]": "bit-array",
      "[object Uint32Array]": "bit-array",
      "[object Uint8ClampedArray]": "bit-array",
      "[object Error]": "error",
      "[object FormData]": "form-data",
      "[object File]": "file",
      "[object Blob]": "blob"
    };
  });
  jkrosoType.types;
  var types = {};
types.number = function (e, t) {
  return e !== e && t !== t;
}, types["function"] = function (e, t, r) {
  return e.toString() === t.toString() && types.object(e, t, r) && equal(e.prototype, t.prototype);
}, types.date = function (e, t) {
  return +e == +t;
}, types.regexp = function (e, t) {
  return e.toString() === t.toString();
}, types.element = function (e, t) {
  return e.outerHTML === t.outerHTML;
}, types.textnode = function (e, t) {
  return e.textContent === t.textContent;
}, types.arguments = types["bit-array"] = types.array = memoGaurd(arrayEqual), types.object = memoGaurd(objectEqual);
var equals = equal,
  isMergeableObject = function isMergeableObject(e) {
    return isNonNullObject(e) && !isSpecial(e);
  },
  canUseSymbol = "function" == typeof Symbol && Symbol["for"],
  REACT_ELEMENT_TYPE = canUseSymbol ? Symbol["for"]("react.element") : 60103;
deepmerge.all = function (e, t) {
  if (!Array.isArray(e)) throw new Error("first argument should be an array");
  return e.reduce(function (e, r) {
    return deepmerge(e, r, t);
  }, {});
};
var deepmerge_1 = deepmerge,
  Context = /*#__PURE__*/React.createContext(),
  deepFreeze = function e(t) {
    return Object.freeze(t), Object.getOwnPropertyNames(t).forEach(function (r) {
      !t.hasOwnProperty(r) || null === t[r] || "object" != _typeof(t[r]) && "function" != typeof t[r] || Object.isFrozen(t[r]) || e(t[r]);
    }), t;
  },
  DEFAULT_STATE = {
    masterSpinnerFinished: !1
  },
  Store = function () {
    function e(t) {
      _classCallCheck(this, e), this.state = deepFreeze(deepmerge_1(DEFAULT_STATE, t)), this.subscriptions = [], this.masterSpinnerSubscriptions = {}, this.setStoreState = this.setStoreState.bind(this), this.getStoreState = this.getStoreState.bind(this), this.subscribe = this.subscribe.bind(this), this.unsubscribe = this.unsubscribe.bind(this), this.updateSubscribers = this.updateSubscribers.bind(this), this.subscribeMasterSpinner = this.subscribeMasterSpinner.bind(this), this.unsubscribeMasterSpinner = this.unsubscribeMasterSpinner.bind(this), this.unsubscribeAllMasterSpinner = this.unsubscribeAllMasterSpinner.bind(this), this.masterSpinnerSuccess = this.masterSpinnerSuccess.bind(this), this.masterSpinnerError = this.masterSpinnerError.bind(this);
    }
    return _createClass(e, [{
      key: "setStoreState",
      value: function value(e, t) {
        this.state = deepFreeze(deepmerge_1(this.state, e)), this.updateSubscribers(t);
      }
    }, {
      key: "getStoreState",
      value: function value() {
        return deepmerge_1({}, this.state);
      }
    }, {
      key: "subscribe",
      value: function value(e) {
        this.subscriptions.push(e);
      }
    }, {
      key: "unsubscribe",
      value: function value(e) {
        var t = this.subscriptions.indexOf(e);
        -1 !== t && this.subscriptions.splice(t, 1);
      }
    }, {
      key: "updateSubscribers",
      value: function value(e) {
        this.subscriptions.forEach(function (e) {
          return e();
        }), "function" == typeof e && e(this.getStoreState());
      }
    }, {
      key: "subscribeMasterSpinner",
      value: function value(e) {
        -1 === Object.keys(this.masterSpinnerSubscriptions).indexOf(e) && (this.masterSpinnerSubscriptions[e] = {
          success: !1,
          error: !1,
          complete: !1
        });
      }
    }, {
      key: "unsubscribeMasterSpinner",
      value: function value(e) {
        return -1 !== Object.keys(this.masterSpinnerSubscriptions).indexOf(e) && (this.setMasterSpinnerFinished(), delete this.masterSpinnerSubscriptions[e]);
      }
    }, {
      key: "unsubscribeAllMasterSpinner",
      value: function value() {
        this.masterSpinnerSubscriptions = {}, this.setMasterSpinnerFinished();
      }
    }, {
      key: "masterSpinnerSuccess",
      value: function value(e) {
        this.masterSpinnerSubscriptions[e].success = !0, this.masterSpinnerSubscriptions[e].complete = !0, this.setMasterSpinnerFinished();
      }
    }, {
      key: "masterSpinnerError",
      value: function value(e) {
        this.masterSpinnerSubscriptions[e].error = !0, this.masterSpinnerSubscriptions[e].complete = !0, this.setMasterSpinnerFinished();
      }
    }, {
      key: "setMasterSpinnerFinished",
      value: function value() {
        this.setStoreState({
          masterSpinnerFinished: this.isMasterSpinnerFinished()
        });
      }
    }, {
      key: "isMasterSpinnerFinished",
      value: function value() {
        var e = this;
        return 0 === Object.keys(this.masterSpinnerSubscriptions).filter(function (t) {
          return !0 !== e.masterSpinnerSubscriptions[t].complete;
        }).length;
      }
    }]), e;
  }(),
  _excluded$1$1 = ["children", "className", "currentSlide", "disableAnimation", "disableKeyboard", "hasMasterSpinner", "interval", "isPageScrollLocked", "isPlaying", "lockOnWindowScroll", "naturalSlideHeight", "naturalSlideWidth", "orientation", "playDirection", "step", "dragStep", "tag", "totalSlides", "touchEnabled", "dragEnabled", "visibleSlides", "infinite", "isIntrinsicHeight"],
  _class,
  CarouselProvider = (_class = function (e) {
    function t(e) {
      var i;
      if (_classCallCheck(this, t), i = r.call(this, e), e.isIntrinsicHeight && "horizontal" !== e.orientation) throw Error('isIntrinsicHeight can only be used in "horizontal" orientation. See Readme for more information.');
      var n = {
        currentSlide: e.currentSlide,
        disableAnimation: e.disableAnimation,
        disableKeyboard: e.disableKeyboard,
        hasMasterSpinner: e.hasMasterSpinner,
        imageErrorCount: 0,
        imageSuccessCount: 0,
        interval: e.interval,
        isPageScrollLocked: e.isPageScrollLocked,
        isPlaying: e.isPlaying,
        lockOnWindowScroll: e.lockOnWindowScroll,
        masterSpinnerThreshold: 0,
        naturalSlideHeight: e.naturalSlideHeight,
        naturalSlideWidth: e.naturalSlideWidth,
        orientation: e.orientation,
        playDirection: e.playDirection,
        privateUnDisableAnimation: !1,
        slideSize: slideSize(e.totalSlides, e.visibleSlides),
        slideTraySize: slideTraySize(e.totalSlides, e.visibleSlides),
        step: e.step,
        dragStep: e.dragStep,
        totalSlides: e.totalSlides,
        touchEnabled: e.touchEnabled,
        dragEnabled: e.dragEnabled,
        visibleSlides: e.visibleSlides,
        infinite: e.infinite,
        isIntrinsicHeight: e.isIntrinsicHeight
      };
      return i.carouselStore = new Store(n), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidUpdate",
      value: function value(e) {
        var t = this,
          r = {};
        ["currentSlide", "disableAnimation", "disableKeyboard", "hasMasterSpinner", "interval", "isPlaying", "naturalSlideHeight", "naturalSlideWidth", "lockOnWindowScroll", "orientation", "playDirection", "step", "dragStep", "totalSlides", "touchEnabled", "dragEnabled", "visibleSlides"].forEach(function (i) {
          e[i] !== t.props[i] && (r[i] = t.props[i]);
        }), this.props.currentSlide !== e.currentSlide && !this.props.disableAnimation && (r.disableAnimation = !0, r.privateUnDisableAnimation = !0), this.props.totalSlides === e.totalSlides && this.props.visibleSlides === e.visibleSlides || (r.slideSize = slideSize(this.props.totalSlides, this.props.visibleSlides), r.slideTraySize = slideTraySize(this.props.totalSlides, this.props.visibleSlides)), this.carouselStore.state.currentSlide >= this.props.totalSlides && (r.currentSlide = Math.max(this.props.totalSlides - 1, 0)), Object.keys(r).length > 0 && this.carouselStore.setStoreState(r);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.carouselStore.unsubscribeAllMasterSpinner();
      }
    }, {
      key: "getStore",
      value: function value() {
        return this.carouselStore;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.children, e.className, e.currentSlide, e.disableAnimation, e.disableKeyboard, e.hasMasterSpinner, e.interval, e.isPageScrollLocked, e.isPlaying, e.lockOnWindowScroll, e.naturalSlideHeight, e.naturalSlideWidth, e.orientation, e.playDirection, e.step, e.dragStep, e.tag),
          r = (e.totalSlides, e.touchEnabled, e.dragEnabled, e.visibleSlides, e.infinite, e.isIntrinsicHeight, _objectWithoutProperties(e, _excluded$1$1)),
          i = cn(["carousel", this.props.className]);
        return /*#__PURE__*/React.createElement(t, _extends({
          className: i
        }, r), /*#__PURE__*/React.createElement(Context.Provider, {
          value: this.carouselStore
        }, this.props.children));
      }
    }]), t;
  }(React.Component), _defineProperty(_class, "propTypes", {
    children: CarouselPropTypes.children.isRequired,
    className: propTypes.string,
    currentSlide: propTypes.number,
    disableAnimation: propTypes.bool,
    disableKeyboard: propTypes.bool,
    hasMasterSpinner: propTypes.bool,
    interval: propTypes.number,
    isPageScrollLocked: propTypes.bool,
    isPlaying: propTypes.bool,
    lockOnWindowScroll: propTypes.bool,
    naturalSlideHeight: propTypes.number.isRequired,
    naturalSlideWidth: propTypes.number.isRequired,
    orientation: CarouselPropTypes.orientation,
    playDirection: CarouselPropTypes.direction,
    step: propTypes.number,
    dragStep: propTypes.number,
    tag: propTypes.string,
    totalSlides: propTypes.number.isRequired,
    touchEnabled: propTypes.bool,
    dragEnabled: propTypes.bool,
    visibleSlides: propTypes.number,
    infinite: propTypes.bool,
    isIntrinsicHeight: propTypes.bool
  }), _defineProperty(_class, "defaultProps", {
    className: null,
    currentSlide: 0,
    disableAnimation: !1,
    disableKeyboard: !1,
    hasMasterSpinner: !1,
    interval: 5e3,
    isPageScrollLocked: !1,
    isPlaying: !1,
    lockOnWindowScroll: !1,
    orientation: "horizontal",
    playDirection: "forward",
    step: 1,
    dragStep: 1,
    tag: "div",
    touchEnabled: !0,
    dragEnabled: !0,
    visibleSlides: 1,
    infinite: !1,
    isIntrinsicHeight: !1
  }), _class);
Context.Consumer;
WithStore(ButtonBack, function (e) {
    return {
      currentSlide: e.currentSlide,
      step: e.step,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides,
      infinite: e.infinite
    };
  });
  var s$1 = {
    buttonFirst: "buttonFirst___2rhFr"
  },
  _excluded$2$1 = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "totalSlides"],
  _class$1,
  ButtonFirst = (_class$1 = function (e) {
    function t() {
      var e;
      return _classCallCheck(this, t), e = r.call(this), e.handleOnClick = e.handleOnClick.bind(_assertThisInitialized(e)), e;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.onClick;
        r.setStoreState({
          currentSlide: 0,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.className),
          r = e.currentSlide,
          i = e.disabled,
          n = (e.onClick, e.totalSlides, _objectWithoutProperties(e, _excluded$2$1)),
          s = cn([s$1.buttonFirst, "carousel__first-button", t]),
          o = null !== i ? i : 0 === r;
        return /*#__PURE__*/React.createElement("button", _extends({
          type: "button",
          "aria-label": "first",
          className: s,
          onClick: this.handleOnClick,
          disabled: o
        }, n), this.props.children);
      }
    }]), t;
  }(React.Component), _defineProperty(_class$1, "propTypes", {
    carouselStore: propTypes.object.isRequired,
    children: CarouselPropTypes.children.isRequired,
    className: propTypes.string,
    currentSlide: propTypes.number.isRequired,
    disabled: propTypes.bool,
    onClick: propTypes.func,
    totalSlides: propTypes.number.isRequired
  }), _defineProperty(_class$1, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null
  }), _class$1);
  WithStore(ButtonFirst, function (e) {
    return {
      currentSlide: e.currentSlide,
      totalSlides: e.totalSlides
    };
  });
  var s$2 = {
    buttonNext: "buttonNext___2mOCa"
  },
  _excluded$3$1 = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "step", "totalSlides", "visibleSlides", "infinite"],
  _class$2,
  ButtonNext = (_class$2 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.currentSlide,
          i = t.onClick,
          n = t.step,
          s = t.carouselStore,
          o = t.infinite,
          a = t.totalSlides - t.visibleSlides,
          l = n + r,
          c = Math.min(l, a);
        o && (c = a === r ? 0 : c), s.setStoreState({
          currentSlide: c,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          r = (e.carouselStore, e.className),
          i = e.currentSlide,
          n = e.disabled,
          s = (e.onClick, e.step, e.totalSlides),
          o = e.visibleSlides,
          a = e.infinite,
          l = _objectWithoutProperties(e, _excluded$3$1),
          c = cn([s$2.buttonNext, "carousel__next-button", r]),
          u = t.setDisabled(n, i, o, s, a);
        return /*#__PURE__*/React.createElement("button", _extends({
          type: "button",
          "aria-label": "next",
          className: c,
          onClick: this.handleOnClick,
          disabled: u
        }, l), this.props.children);
      }
    }], [{
      key: "setDisabled",
      value: function value(e, t, r, i, n) {
        return null !== e ? e : t >= i - r && !n;
      }
    }]), t;
  }(React.PureComponent), _defineProperty(_class$2, "propTypes", {
    carouselStore: propTypes.object.isRequired,
    children: CarouselPropTypes.children.isRequired,
    className: propTypes.string,
    currentSlide: propTypes.number.isRequired,
    disabled: propTypes.bool,
    onClick: propTypes.func,
    step: propTypes.number.isRequired,
    totalSlides: propTypes.number.isRequired,
    visibleSlides: propTypes.number.isRequired,
    infinite: propTypes.bool
  }), _defineProperty(_class$2, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null,
    infinite: !1
  }), _class$2);
  WithStore(ButtonNext, function (e) {
    return {
      currentSlide: e.currentSlide,
      step: e.step,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides,
      infinite: e.infinite
    };
  });
  var s$3 = {
    buttonLast: "buttonLast___2yuh0"
  },
  _excluded$4$1 = ["carouselStore", "className", "currentSlide", "disabled", "onClick", "totalSlides", "visibleSlides"],
  _class$3,
  ButtonLast = (_class$3 = function (e) {
    function t() {
      var e;
      return _classCallCheck(this, t), e = r.call(this), e.handleOnClick = e.handleOnClick.bind(_assertThisInitialized(e)), e;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.onClick,
          n = t.totalSlides,
          s = t.visibleSlides;
        r.setStoreState({
          currentSlide: n - s,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.className),
          r = e.currentSlide,
          i = e.disabled,
          n = (e.onClick, e.totalSlides),
          s = e.visibleSlides,
          o = _objectWithoutProperties(e, _excluded$4$1),
          a = cn([s$3.buttonLast, "carousel__last-button", t]),
          l = null !== i ? i : r >= n - s;
        return /*#__PURE__*/React.createElement("button", _extends({
          type: "button",
          "aria-label": "last",
          className: a,
          onClick: this.handleOnClick,
          disabled: l
        }, o), this.props.children);
      }
    }]), t;
  }(React.Component), _defineProperty(_class$3, "propTypes", {
    carouselStore: propTypes.object.isRequired,
    children: CarouselPropTypes.children.isRequired,
    className: propTypes.string,
    currentSlide: propTypes.number.isRequired,
    disabled: propTypes.bool,
    onClick: propTypes.func,
    totalSlides: propTypes.number.isRequired,
    visibleSlides: propTypes.number.isRequired
  }), _defineProperty(_class$3, "defaultProps", {
    className: null,
    disabled: null,
    onClick: null
  }), _class$3);
  WithStore(ButtonLast, function (e) {
    return {
      currentSlide: e.currentSlide,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides
    };
  });
  var s$4 = {
    buttonNext: "buttonNext___3Lm3s"
  },
  _excluded$5$1 = ["carouselStore", "children", "childrenPaused", "childrenPlaying", "className", "isPlaying", "onClick"],
  _class$4,
  ButtonPlay = (_class$4 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props.onClick;
        this.props.carouselStore.setStoreState({
          isPlaying: !this.props.isPlaying
        }, null !== t && t.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children, e.childrenPaused),
          r = e.childrenPlaying,
          i = e.className,
          n = e.isPlaying,
          s = (e.onClick, _objectWithoutProperties(e, _excluded$5$1)),
          o = cn([s$4.buttonNext, "carousel__play-button", i]);
        return /*#__PURE__*/React.createElement("button", _extends({
          type: "button",
          "aria-label": "play",
          className: o,
          onClick: this.handleOnClick
        }, s), n && r, !n && t, this.props.children);
      }
    }]), t;
  }(React.PureComponent), _defineProperty(_class$4, "propTypes", {
    carouselStore: propTypes.object.isRequired,
    children: propTypes.node,
    childrenPaused: propTypes.node,
    childrenPlaying: propTypes.node,
    className: propTypes.string,
    isPlaying: propTypes.bool.isRequired,
    onClick: propTypes.func
  }), _defineProperty(_class$4, "defaultProps", {
    children: null,
    childrenPaused: null,
    childrenPlaying: null,
    className: null,
    onClick: null
  }), _class$4);
  WithStore(ButtonPlay, function (e) {
    return {
      isPlaying: e.isPlaying
    };
  });
  var s$5 = {
    dot: "dot___3c3SI"
  },
  _excluded$6$1 = ["carouselStore", "children", "className", "currentSlide", "disabled", "onClick", "selected", "slide", "totalSlides", "visibleSlides"],
  _class$5,
  Dot = (_class$5 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnClick = i.handleOnClick.bind(_assertThisInitialized(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "handleOnClick",
      value: function value(e) {
        var t = this.props,
          r = t.carouselStore,
          i = t.onClick,
          n = t.slide,
          s = t.totalSlides,
          o = t.visibleSlides,
          a = n >= s - o ? s - o : n;
        r.setStoreState({
          currentSlide: a,
          isPlaying: !1
        }, null !== i && i.call(this, e));
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children, e.className),
          r = e.currentSlide,
          i = e.disabled,
          n = (e.onClick, e.selected),
          s = e.slide,
          o = (e.totalSlides, e.visibleSlides),
          a = _objectWithoutProperties(e, _excluded$6$1),
          l = s >= r && s < r + o,
          c = "boolean" == typeof n ? n : l,
          u = !0 === l,
          p = "boolean" == typeof i ? i : u,
          d = cn([s$5.dot, c && s$5.dotSelected, "carousel__dot", "carousel__dot--".concat(s), c && "carousel__dot--selected", t]);
        return /*#__PURE__*/React.createElement("button", _extends({
          "aria-label": "slide dot",
          type: "button",
          onClick: this.handleOnClick,
          className: d,
          disabled: p
        }, a), this.props.children);
      }
    }]), t;
  }(React.Component), _defineProperty(_class$5, "propTypes", {
    carouselStore: propTypes.object.isRequired,
    children: CarouselPropTypes.children,
    className: propTypes.string,
    currentSlide: propTypes.number.isRequired,
    disabled: propTypes.bool,
    onClick: propTypes.func,
    selected: propTypes.bool,
    slide: propTypes.number.isRequired,
    totalSlides: propTypes.number.isRequired,
    visibleSlides: propTypes.number.isRequired
  }), _defineProperty(_class$5, "defaultProps", {
    children: null,
    className: null,
    disabled: null,
    onClick: null,
    selected: null
  }), _class$5),
  Dot$1 = WithStore(Dot, function (e) {
    return {
      currentSlide: e.currentSlide,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides
    };
  }),
  s$6 = {},
  _excluded$7$1 = ["renderDots"],
  _excluded2 = ["carouselStore", "children", "className", "currentSlide", "dotNumbers", "totalSlides", "visibleSlides", "disableActiveDots", "showAsSelectedForCurrentSlideOnly", "renderDots"],
  _class$6,
  DotGroup = (_class$6 = function (e) {
    function t() {
      return _classCallCheck(this, t), r.apply(this, arguments);
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "renderDots",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.totalSlides,
          i = e.visibleSlides,
          n = e.disableActiveDots,
          s = e.showAsSelectedForCurrentSlideOnly,
          o = e.renderDots;
        if (o) {
          var a = this.props;
          a.renderDots;
          return o(_objectWithoutProperties(a, _excluded$7$1));
        }
        for (var l = [], c = 0; c < r; c += 1) {
          var u = c >= t && c < t + i,
            p = c === t,
            d = s ? p : u,
            h = c >= r - i ? r - i : c;
          l.push( /*#__PURE__*/React.createElement(Dot$1, {
            key: c,
            slide: h,
            selected: d,
            disabled: !!n && d
          }, /*#__PURE__*/React.createElement("span", {
            className: cn["carousel__dot-group-dot"]
          }, this.props.dotNumbers && c + 1)));
        }
        return l;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children),
          r = e.className,
          i = (e.currentSlide, e.dotNumbers, e.totalSlides, e.visibleSlides, e.disableActiveDots, e.showAsSelectedForCurrentSlideOnly, e.renderDots, _objectWithoutProperties(e, _excluded2)),
          n = cn([s$6.DotGroup, "carousel__dot-group", r]);
        return /*#__PURE__*/React.createElement("div", _extends({
          className: n
        }, i), this.renderDots(), t);
      }
    }]), t;
  }(React.Component), _defineProperty(_class$6, "propTypes", {
    children: CarouselPropTypes.children,
    className: propTypes.string,
    currentSlide: propTypes.number.isRequired,
    carouselStore: propTypes.object.isRequired,
    totalSlides: propTypes.number.isRequired,
    visibleSlides: propTypes.number.isRequired,
    dotNumbers: propTypes.bool,
    disableActiveDots: propTypes.bool,
    showAsSelectedForCurrentSlideOnly: propTypes.bool,
    renderDots: propTypes.func
  }), _defineProperty(_class$6, "defaultProps", {
    children: null,
    className: null,
    dotNumbers: !1,
    disableActiveDots: !0,
    showAsSelectedForCurrentSlideOnly: !1,
    renderDots: null
  }), _class$6);
  WithStore(DotGroup, function (e) {
    return {
      currentSlide: e.currentSlide,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides
    };
  });
  var s$7 = {
    image: "image___xtQGH"
  },
  _excluded$8$1 = ["src", "alt"],
  _excluded2$1 = ["carouselStore", "children", "className", "hasMasterSpinner", "isBgImage", "onError", "onLoad", "renderError", "renderLoading", "style", "tag"],
  Image = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.state = {
        imageStatus: LOADING
      }, i.handleImageLoad = i.handleImageLoad.bind(_assertThisInitialized(i)), i.handleImageError = i.handleImageError.bind(_assertThisInitialized(i)), i.image = null, i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidMount",
      value: function value() {
        t.subscribeMasterSpinner(this.props), this.initImage();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        e.src !== this.props.src && (t.unsubscribeMasterSpinner(e), t.subscribeMasterSpinner(this.props), this.initImage());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        t.unsubscribeMasterSpinner(this.props), this.image.removeEventListener("load", this.handleImageLoad), this.image.removeEventListener("error", this.handleImageError), this.image = null;
      }
    }, {
      key: "initImage",
      value: function value() {
        if (this.setState({
          imageStatus: LOADING
        }), this.image = document.createElement("img"), this.image.addEventListener("load", this.handleImageLoad, !1), this.image.addEventListener("error", this.handleImageError, !1), this.image.src = this.props.src, this.image.readyState || this.image.complete) {
          var e = this.image.src;
          this.image.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==", this.image.src = e;
        }
      }
    }, {
      key: "handleImageLoad",
      value: function value(e) {
        this.setState({
          imageStatus: SUCCESS
        }), this.props.hasMasterSpinner && this.props.carouselStore.masterSpinnerSuccess(this.props.src), this.props.onLoad && this.props.onLoad(e);
      }
    }, {
      key: "handleImageError",
      value: function value(e) {
        this.setState({
          imageStatus: ERROR
        }), this.props.hasMasterSpinner && this.props.carouselStore.masterSpinnerError(this.props.src), this.props.onError && this.props.onError(e);
      }
    }, {
      key: "tempTag",
      value: function value() {
        return "img" === this.props.tag ? "div" : this.props.tag;
      }
    }, {
      key: "customRender",
      value: function value(e) {
        return "function" == typeof this.props[e] ? this.props[e]() : this.props.children;
      }
    }, {
      key: "renderLoading",
      value: function value(e) {
        var t = this.tempTag(),
          r = cn([s$7.image, s$7.imageLoading, "carousel__image", this.props.isBgImage && "carousel__image--with-background", "carousel__image--loading", this.props.className]);
        return /*#__PURE__*/React.createElement(t, _extends({
          className: r
        }, e), this.customRender("renderLoading"));
      }
    }, {
      key: "renderError",
      value: function value(e) {
        var t = this.tempTag(),
          r = cn([s$7.image, s$7.imageError, "carousel__image", this.props.isBgImage && "carousel__image--with-background", "carousel__image--error", this.props.className]);
        return /*#__PURE__*/React.createElement(t, _extends({
          className: r
        }, e), this.customRender("renderError"));
      }
    }, {
      key: "renderSuccess",
      value: function value(e) {
        var t = this.props,
          r = t.style,
          i = t.tag,
          n = cn([s$7.image, "carousel__image", this.props.isBgImage && "carousel__image--with-background", "carousel__image--success", this.props.className]),
          s = _extends({}, r),
          o = e;
        if ("img" !== i) {
          var a = e.src;
          e.alt;
          o = _objectWithoutProperties(e, _excluded$8$1), s = _extends({}, r, {
            backgroundImage: 'url("'.concat(a, '")'),
            backgroundSize: "cover"
          });
        }
        return /*#__PURE__*/React.createElement(i, _extends({
          className: n,
          style: s
        }, o), this.props.children);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = (e.carouselStore, e.children, e.className, e.hasMasterSpinner, e.isBgImage, e.onError, e.onLoad, e.renderError, e.renderLoading, e.style, e.tag, _objectWithoutProperties(e, _excluded2$1));
        switch (this.state.imageStatus) {
          case LOADING:
            return this.renderLoading(t);
          case SUCCESS:
            return this.renderSuccess(t);
          case ERROR:
            return this.renderError(t);
          default:
            throw new Error("unknown value for this.state.imageStatus");
        }
      }
    }], [{
      key: "subscribeMasterSpinner",
      value: function value(e) {
        e.hasMasterSpinner && e.carouselStore.subscribeMasterSpinner(e.src);
      }
    }, {
      key: "unsubscribeMasterSpinner",
      value: function value(e) {
        e.hasMasterSpinner && e.carouselStore.unsubscribeMasterSpinner(e.src);
      }
    }]), t;
  }(React.Component);
_defineProperty(Image, "propTypes", {
  alt: propTypes.string,
  carouselStore: propTypes.object.isRequired,
  children: CarouselPropTypes.children,
  className: propTypes.string,
  hasMasterSpinner: propTypes.bool.isRequired,
  isBgImage: CarouselPropTypes.isBgImage,
  onError: propTypes.func,
  onLoad: propTypes.func,
  renderError: propTypes.func,
  renderLoading: propTypes.func,
  src: propTypes.string.isRequired,
  style: propTypes.object,
  tag: propTypes.string
}), _defineProperty(Image, "defaultProps", {
  alt: "",
  children: null,
  className: null,
  isBgImage: !1,
  onError: null,
  onLoad: null,
  renderError: null,
  renderLoading: null,
  style: null,
  tag: "img"
});
var Image$1 = WithStore(Image, function (e) {
    return {
      hasMasterSpinner: e.hasMasterSpinner,
      orientation: e.orientation
    };
  }),
  s$8 = {
    spinner: "spinner___27VUp",
    spin: "spin___S3UuE"
  },
  _excluded$9$1 = ["className"],
  _class$7,
  Spinner = (_class$7 = function (e) {
    function t() {
      return _classCallCheck(this, t), r.apply(this, arguments);
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.className,
          r = _objectWithoutProperties(e, _excluded$9$1),
          i = cn([s$8.spinner, "carousel__spinner", t]);
        return /*#__PURE__*/React.createElement("div", _extends({
          className: i
        }, r));
      }
    }]), t;
  }(React.PureComponent), _defineProperty(_class$7, "propTypes", {
    className: propTypes.string
  }), _defineProperty(_class$7, "defaultProps", {
    className: null
  }), _class$7),
  s$9 = {
    container: "container___2O72F",
    overlay: "overlay___IV4qY",
    hover: "hover___MYy31",
    zoom: "zoom___3kqYk",
    loading: "loading___1pvNI",
    imageLoadingSpinnerContainer: "imageLoadingSpinnerContainer___3UIPD"
  },
  _excluded$a$1 = ["alt", "bgImageProps", "bgImageTag", "carouselStore", "className", "imageClassName", "overlayClassName", "isPinchZoomEnabled", "spinner", "src", "srcZoomed", "tag"],
  _class$8,
  MOUSE_SCALE = 2,
  MAX_TOUCH_SCALE = 3,
  ImageWithZoom = (_class$8 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.state = {
        isImageLoading: !0,
        isHovering: !1,
        isZooming: !1,
        x: null,
        y: null,
        scale: 1
      }, i.tpCache = {}, i.handleImageComplete = i.handleImageComplete.bind(_assertThisInitialized(i)), i.handleOnMouseMove = i.handleOnMouseMove.bind(_assertThisInitialized(i)), i.handleOnMouseOut = i.handleOnMouseOut.bind(_assertThisInitialized(i)), i.handleOnMouseOver = i.handleOnMouseOver.bind(_assertThisInitialized(i)), i.handleOnTouchEnd = i.handleOnTouchEnd.bind(_assertThisInitialized(i)), i.handleOnTouchMove = i.handleOnTouchMove.bind(_assertThisInitialized(i)), i.handleOnTouchStart = i.handleOnTouchStart.bind(_assertThisInitialized(i)), i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidUpdate",
      value: function value(e, t) {
        !1 === t.isZooming && !0 === this.state.isZooming && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !0
        }), !0 === t.isZooming && !1 === this.state.isZooming && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !1
        });
      }
    }, {
      key: "handleImageComplete",
      value: function value() {
        this.setState({
          isImageLoading: !1
        });
      }
    }, {
      key: "handleOnMouseOver",
      value: function value() {
        this.state.isZooming || this.setState({
          isHovering: !0,
          scale: MOUSE_SCALE
        });
      }
    }, {
      key: "handleOnMouseOut",
      value: function value() {
        this.state.isZooming || this.setState({
          isHovering: !1,
          scale: 1
        });
      }
    }, {
      key: "handleOnMouseMove",
      value: function value(e) {
        if (!this.state.isZooming) {
          var t = pct(e.nativeEvent.offsetX / e.target.offsetWidth * 100),
            r = pct(e.nativeEvent.offsetY / e.target.offsetHeight * 100);
          this.setState({
            x: t,
            y: r
          });
        }
      }
    }, {
      key: "handleOnTouchStart",
      value: function value(e) {
        var t = this;
        this.props.isPinchZoomEnabled && (_toConsumableArray(e.targetTouches).forEach(function (e) {
          t.tpCache[e.identifier] = {
            clientX: e.clientX,
            clientY: e.clientY
          };
        }), this.setState(function (e) {
          return {
            isZooming: e.isZooming || Object.keys(t.tpCache).length > 1
          };
        }));
      }
    }, {
      key: "handleOnTouchMove",
      value: function value(e) {
        var r = this;
        if (this.state.isZooming) {
          e.persist();
          var i = _toConsumableArray(e.targetTouches).filter(function (e) {
            return r.tpCache[e.identifier];
          }).slice(0, 2);
          if (2 === i.length) {
            e.stopPropagation();
            var n = e.target.getBoundingClientRect(),
              s = i[0].identifier,
              o = i[1].identifier,
              a = {
                x1: this.tpCache[s].clientX,
                y1: this.tpCache[s].clientY,
                x2: this.tpCache[o].clientX,
                y2: this.tpCache[o].clientY
              };
            a.distance = t.distanceBetweenTwoTouches(_objectSpread2({}, a));
            var l = t.midpointBetweenTwoTouches(_objectSpread2({}, a));
            a.cx = l.x, a.cy = l.y;
            var c = {
              x1: i[0].clientX,
              y1: i[0].clientY,
              x2: i[1].clientX,
              y2: i[1].clientY
            };
            c.distance = t.distanceBetweenTwoTouches(_objectSpread2({}, c));
            var u = t.midpointBetweenTwoTouches(_objectSpread2({}, c));
            c.cx = u.x, c.cy = u.y;
            var p = pct(boundedRange({
                min: 0,
                max: 100,
                x: (c.cx - n.left) / n.width * 100
              })),
              d = pct(boundedRange({
                min: 0,
                max: 100,
                x: (c.cy - n.top) / n.height * 100
              })),
              h = function h(e) {
                return boundedRange({
                  min: 1,
                  max: MAX_TOUCH_SCALE,
                  x: e.scale + (c.distance - a.distance) / 100
                });
              };
            this.setState(function (e) {
              return {
                isZooming: 1 !== h(e),
                scale: h(e),
                x: p,
                y: d
              };
            });
          }
        }
      }
    }, {
      key: "handleOnTouchEnd",
      value: function value(e) {
        var t = this;
        this.props.isPinchZoomEnabled && (_toConsumableArray(e.changedTouches).forEach(function (e) {
          delete t.tpCache[e.identifier];
        }), 0 === Object.keys(this.tpCache).length && this.setState({
          isZooming: !1
        }));
      }
    }, {
      key: "renderLoading",
      value: function value() {
        if (this.state.isImageLoading) {
          var e = this.props.spinner;
          return /*#__PURE__*/React.createElement("div", {
            className: cn([s$9.imageLoadingSpinnerContainer, "carousel__image-loading-spinner-container"])
          }, e && e(), !e && /*#__PURE__*/React.createElement(Spinner, null));
        }
        return null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
          t = e.alt,
          r = e.bgImageProps,
          i = e.bgImageTag,
          n = (e.carouselStore, e.className),
          s = e.imageClassName,
          o = e.overlayClassName,
          a = (e.isPinchZoomEnabled, e.spinner, e.src),
          l = e.srcZoomed,
          c = e.tag,
          u = _objectWithoutProperties(e, _excluded$a$1),
          p = cn([s$9.container, n]),
          d = cn([s$9.image, "carousel__zoom-image", s]),
          h = cn([s$9.overlay, "carousel__zoom-image-overlay", this.state.isHovering && s$9.hover, this.state.isZooming && s$9.zoom, this.state.isHovering && "carousel__zoom-image-overlay--hovering", this.state.isZooming && "carousel__zoom-image-overlay--zooming", o]),
          S = {};
        return (this.state.isHovering || this.state.isZooming) && (S.transformOrigin = "".concat(this.state.x, " ").concat(this.state.y), S.transform = "scale(".concat(this.state.scale, ")")), /*#__PURE__*/React.createElement(c, _extends({
          className: p
        }, u), /*#__PURE__*/React.createElement(Image$1, _extends({
          alt: t,
          className: d,
          tag: i,
          src: a,
          onLoad: this.handleImageComplete,
          onError: this.handleImageComplete
        }, r)), /*#__PURE__*/React.createElement(Image$1, {
          className: h,
          tag: "div",
          src: l || a,
          style: S,
          isBgImage: !0,
          onFocus: this.handleOnMouseOver,
          onMouseOver: this.handleOnMouseOver,
          onBlur: this.handleOnMouseOut,
          onMouseOut: this.handleOnMouseOut,
          onMouseMove: this.handleOnMouseMove,
          onTouchStart: this.handleOnTouchStart,
          onTouchEnd: this.handleOnTouchEnd,
          onTouchMove: this.handleOnTouchMove
        }), this.renderLoading());
      }
    }], [{
      key: "midpointBetweenTwoTouches",
      value: function value(e) {
        var t = e.x1,
          r = e.y1;
        return {
          x: (t + e.x2) / 2,
          y: (r + e.y2) / 2
        };
      }
    }, {
      key: "distanceBetweenTwoTouches",
      value: function value(e) {
        var t = e.x1,
          r = e.y1,
          i = e.x2,
          n = e.y2;
        return Math.sqrt(Math.pow(i - t, 2) + Math.pow(n - r, 2));
      }
    }]), t;
  }(React.Component), _defineProperty(_class$8, "propTypes", {
    alt: propTypes.string,
    bgImageProps: propTypes.object,
    bgImageTag: propTypes.string,
    carouselStore: propTypes.object.isRequired,
    className: propTypes.string,
    imageClassName: propTypes.string,
    overlayClassName: propTypes.string,
    spinner: propTypes.func,
    src: propTypes.string.isRequired,
    srcZoomed: propTypes.string,
    tag: propTypes.string,
    isPinchZoomEnabled: propTypes.bool
  }), _defineProperty(_class$8, "defaultProps", {
    alt: void 0,
    bgImageProps: {},
    bgImageTag: "div",
    className: null,
    imageClassName: null,
    overlayClassName: null,
    isPinchZoomEnabled: !0,
    spinner: null,
    srcZoomed: null,
    tag: "div"
  }), _class$8);
  WithStore(ImageWithZoom, function () {
    return {};
  });
  var s$a = {
    slide: "slide___3-Nqo",
    slideHorizontal: "slideHorizontal___1NzNV",
    slideInner: "slideInner___2mfX9",
    focusRing: "focusRing___1airF"
  },
  _excluded$b$1 = ["ariaLabel", "carouselStore", "children", "className", "classNameHidden", "classNameVisible", "currentSlide", "index", "innerClassName", "innerTag", "naturalSlideHeight", "naturalSlideWidth", "onBlur", "onFocus", "orientation", "slideSize", "style", "tabIndex", "tag", "totalSlides", "visibleSlides", "isIntrinsicHeight"],
  _class$9,
  Slide = (_class$9 = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.handleOnFocus = i.handleOnFocus.bind(_assertThisInitialized(i)), i.handleOnBlur = i.handleOnBlur.bind(_assertThisInitialized(i)), i.state = {
        focused: !1
      }, i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "isVisible",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.index,
          i = e.visibleSlides;
        return r >= t && r < t + i;
      }
    }, {
      key: "handleOnFocus",
      value: function value(e) {
        var t = this,
          r = this.props.onFocus;
        this.setState({
          focused: !0
        }, function () {
          null !== r && r.call(t, e);
        });
      }
    }, {
      key: "handleOnBlur",
      value: function value(e) {
        var t = this,
          r = this.props.onBlur;
        this.setState({
          focused: !1
        }, function () {
          null !== r && r.call(t, e);
        });
      }
    }, {
      key: "renderFocusRing",
      value: function value() {
        return this.state.focused ? /*#__PURE__*/React.createElement("div", {
          className: [s$a.focusRing, "carousel__slide-focus-ring"].join(" ")
        }) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.ariaLabel,
          i = (t.carouselStore, t.children, t.className),
          n = t.classNameHidden,
          s = t.classNameVisible,
          o = (t.currentSlide, t.index, t.innerClassName),
          a = t.innerTag,
          l = t.naturalSlideHeight,
          c = t.naturalSlideWidth,
          u = (t.onBlur, t.onFocus, t.orientation),
          p = t.slideSize,
          d = t.style,
          h = t.tabIndex,
          S = t.tag,
          y = t.totalSlides,
          b = (t.visibleSlides, t.isIntrinsicHeight),
          m = _objectWithoutProperties(t, _excluded$b$1),
          f = {};
        "horizontal" === u ? (f.width = pct(p), f.paddingBottom = pct(100 * l / (c * y))) : (f.width = pct(100), f.paddingBottom = pct(100 * l / c));
        var g = {};
        b && ("horizontal" === u ? f.height = "unset" : f.width = "unset", f.paddingBottom = "unset", g.position = "unset");
        var v = _extends({}, f, d),
          _ = this.isVisible(),
          T = cn([s$a.slide, "horizontal" === u && s$a.slideHorizontal, "carousel__slide", this.state.focused && "carousel__slide--focused", _ && s, _ && "carousel__slide--visible", !_ && n, !_ && "carousel__slide--hidden", i]),
          k = cn([s$a.slideInner, "carousel__inner-slide", o]),
          C = this.isVisible() ? 0 : -1,
          O = "number" == typeof h ? h : C;
        return /*#__PURE__*/React.createElement(S, _extends({
          ref: function ref(t) {
            e.tagRef = t;
          },
          tabIndex: O,
          "aria-selected": this.isVisible(),
          "aria-label": r,
          role: "option",
          onFocus: this.handleOnFocus,
          onBlur: this.handleOnBlur,
          className: T,
          style: v
        }, m), /*#__PURE__*/React.createElement(a, {
          ref: function ref(t) {
            e.innerTagRef = t;
          },
          className: k,
          style: g
        }, this.props.children, this.renderFocusRing()));
      }
    }]), t;
  }(React.PureComponent), _defineProperty(_class$9, "propTypes", {
    ariaLabel: propTypes.string,
    carouselStore: propTypes.object,
    children: CarouselPropTypes.children,
    className: propTypes.string,
    classNameHidden: propTypes.string,
    classNameVisible: propTypes.string,
    currentSlide: propTypes.number.isRequired,
    index: propTypes.number.isRequired,
    innerClassName: propTypes.string,
    innerTag: propTypes.string,
    naturalSlideHeight: propTypes.number.isRequired,
    naturalSlideWidth: propTypes.number.isRequired,
    onBlur: propTypes.func,
    onFocus: propTypes.func,
    orientation: CarouselPropTypes.orientation.isRequired,
    slideSize: propTypes.number.isRequired,
    style: propTypes.object,
    tabIndex: propTypes.number,
    tag: propTypes.string,
    totalSlides: propTypes.number.isRequired,
    visibleSlides: propTypes.number.isRequired,
    isIntrinsicHeight: propTypes.bool
  }), _defineProperty(_class$9, "defaultProps", {
    ariaLabel: "slide",
    carouselStore: null,
    children: null,
    className: null,
    classNameHidden: null,
    classNameVisible: null,
    innerClassName: null,
    innerTag: "div",
    onBlur: null,
    onFocus: null,
    style: {},
    tabIndex: null,
    tag: "div",
    isIntrinsicHeight: !1
  }), _class$9),
  index$7 = WithStore(Slide, function (e) {
    return {
      currentSlide: e.currentSlide,
      naturalSlideHeight: e.naturalSlideHeight,
      naturalSlideWidth: e.naturalSlideWidth,
      orientation: e.orientation,
      slideSize: e.slideSize,
      totalSlides: e.totalSlides,
      visibleSlides: e.visibleSlides,
      isIntrinsicHeight: e.isIntrinsicHeight
    };
  }),
  GetScrollParent = function () {
    function e() {
      _classCallCheck(this, e);
    }
    return _createClass(e, [{
      key: "parents",
      value: function value(e, t) {
        return null === e.parentNode ? t : this.parents(e.parentNode, t.concat([e]));
      }
    }, {
      key: "scrollParent",
      value: function value(t) {
        for (var r = this.parents(t.parentNode, []), i = 0; i < r.length; i += 1) if (e.scroll(r[i])) return r[i];
        return document.scrollingElement || document.documentElement;
      }
    }, {
      key: "getScrollParent",
      value: function value(t) {
        return e.isNodeValid(t) ? this.scrollParent(t) : null;
      }
    }], [{
      key: "style",
      value: function value(e, t) {
        return getComputedStyle(e, null).getPropertyValue(t);
      }
    }, {
      key: "overflow",
      value: function value(t) {
        return e.style(t, "overflow") + e.style(t, "overflow-y") + e.style(t, "overflow-x");
      }
    }, {
      key: "scroll",
      value: function value(t) {
        return /(auto|scroll)/.test(e.overflow(t));
      }
    }, {
      key: "isNodeValid",
      value: function value(e) {
        return e instanceof HTMLElement || e instanceof SVGElement;
      }
    }]), e;
  }(),
  s$b = {
    horizontalSlider: "horizontalSlider___281Ls",
    horizontalSliderTray: "horizontalSliderTray___1L-0W",
    verticalSlider: "verticalSlider___34ZFD",
    verticalSliderTray: "verticalSliderTray___267D8",
    verticalTray: "verticalTray___12Key",
    verticalSlideTrayWrap: "verticalSlideTrayWrap___2nO7o",
    sliderTray: "sliderTray___-vHFQ",
    sliderAnimation: "sliderAnimation___300FY",
    masterSpinnerContainer: "masterSpinnerContainer___1Z6hB"
  },
  _excluded$c$1 = ["ariaLabel", "carouselStore", "children", "className", "classNameAnimation", "classNameTray", "classNameTrayWrap", "currentSlide", "disableAnimation", "disableKeyboard", "dragEnabled", "hasMasterSpinner", "interval", "isPageScrollLocked", "isPlaying", "lockOnWindowScroll", "masterSpinnerFinished", "moveThreshold", "naturalSlideHeight", "naturalSlideWidth", "onMasterSpinner", "orientation", "playDirection", "privateUnDisableAnimation", "slideSize", "slideTraySize", "spinner", "style", "tabIndex", "totalSlides", "touchEnabled", "trayProps", "trayTag", "visibleSlides", "isIntrinsicHeight"],
  _excluded2$2 = ["dragStep", "step", "infinite", "preventVerticalScrollOnTouch", "preventingVerticalScroll", "horizontalPixelThreshold", "verticalPixelThreshold"],
  _excluded3 = ["className", "onClickCapture", "onMouseDown", "onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart", "ref", "style"],
  _class$a,
  Slider = (_class$a = function (e) {
    function t(e) {
      var i;
      return _classCallCheck(this, t), i = r.call(this, e), i.getSliderRef = i.getSliderRef.bind(_assertThisInitialized(i)), i.handleDocumentScroll = i.handleDocumentScroll.bind(_assertThisInitialized(i)), i.handleOnClickCapture = i.handleOnClickCapture.bind(_assertThisInitialized(i)), i.handleOnKeyDown = i.handleOnKeyDown.bind(_assertThisInitialized(i)), i.handleOnMouseDown = i.handleOnMouseDown.bind(_assertThisInitialized(i)), i.handleOnMouseMove = i.handleOnMouseMove.bind(_assertThisInitialized(i)), i.handleOnMouseUp = i.handleOnMouseUp.bind(_assertThisInitialized(i)), i.handleOnTouchCancel = i.handleOnTouchCancel.bind(_assertThisInitialized(i)), i.handleOnTouchEnd = i.handleOnTouchEnd.bind(_assertThisInitialized(i)), i.handleOnTouchMove = i.handleOnTouchMove.bind(_assertThisInitialized(i)), i.handleOnTouchStart = i.handleOnTouchStart.bind(_assertThisInitialized(i)), i.playBackward = i.playBackward.bind(_assertThisInitialized(i)), i.playForward = i.playForward.bind(_assertThisInitialized(i)), i.callCallback = i.callCallback.bind(_assertThisInitialized(i)), i.blockWindowScroll = i.blockWindowScroll.bind(_assertThisInitialized(i)), i.state = {
        cancelNextClick: !1,
        deltaX: 0,
        deltaY: 0,
        isBeingMouseDragged: !1,
        isBeingTouchDragged: !1,
        preventingVerticalScroll: !1,
        startX: 0,
        startY: 0
      }, i.interval = null, i.isDocumentScrolling = null, i.moveTimer = null, i.originalOverflow = null, i.scrollParent = null, i.scrollStopTimer = null, i;
    }
    _inherits(t, e);
    var r = _createSuper(t);
    return _createClass(t, [{
      key: "componentDidMount",
      value: function value() {
        this.props.lockOnWindowScroll && window.addEventListener("scroll", this.handleDocumentScroll, !1), (this.props.touchEnabled || this.props.preventVerticalScrollOnTouch) && window.addEventListener("touchmove", this.blockWindowScroll, !1), document.documentElement.addEventListener("mouseleave", this.handleOnMouseUp, !1), document.documentElement.addEventListener("mousemove", this.handleOnMouseMove, !1), document.documentElement.addEventListener("mouseup", this.handleOnMouseUp, !1), this.props.isPlaying && this.play();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        !e.isPlaying && this.props.isPlaying && this.play(), e.isPlaying && !this.props.isPlaying && this.stop(), !e.isPageScrollLocked && this.props.isPageScrollLocked && this.lockScroll(), e.isPageScrollLocked && !this.props.isPageScrollLocked && this.unlockScroll(), !1 === e.privateUnDisableAnimation && !0 === this.props.privateUnDisableAnimation && this.props.carouselStore.setStoreState({
          privateUnDisableAnimation: !1,
          disableAnimation: !1
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        document.documentElement.removeEventListener("mouseleave", this.handleOnMouseUp, !1), document.documentElement.removeEventListener("mousemove", this.handleOnMouseMove, !1), document.documentElement.removeEventListener("mouseup", this.handleOnMouseUp, !1), window.removeEventListener("scroll", this.handleDocumentScroll, !1), window.removeEventListener("touchmove", this.blockWindowScroll, !1), this.stop(), window.cancelAnimationFrame.call(window, this.moveTimer), window.clearTimeout(this.scrollStopTimer), this.isDocumentScrolling = null, this.moveTimer = null, this.scrollStopTimer = null;
      }
    }, {
      key: "getSliderRef",
      value: function value(e) {
        this.sliderTrayElement = e;
      }
    }, {
      key: "fakeOnDragStart",
      value: function value(e) {
        var t = e.screenX,
          r = e.screenY,
          i = e.touchDrag,
          n = void 0 !== i && i,
          s = e.mouseDrag,
          o = void 0 !== s && s;
        this.props.carouselStore.setStoreState({
          isPlaying: !1
        }), window.cancelAnimationFrame.call(window, this.moveTimer), "vertical" === this.props.orientation && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !0
        }), this.setState({
          isBeingTouchDragged: n,
          isBeingMouseDragged: o,
          startX: t,
          startY: r
        });
      }
    }, {
      key: "fakeOnDragMove",
      value: function value(e, t) {
        var r = this;
        this.moveTimer = window.requestAnimationFrame.call(window, function () {
          r.setState(function (i) {
            return {
              deltaX: e - i.startX,
              deltaY: t - i.startY,
              preventingVerticalScroll: Math.abs(t - i.startY) <= r.props.verticalPixelThreshold && Math.abs(e - i.startX) >= r.props.horizontalPixelThreshold
            };
          });
        });
      }
    }, {
      key: "fakeOnDragEnd",
      value: function value() {
        window.cancelAnimationFrame.call(window, this.moveTimer), this.computeCurrentSlide(), "vertical" === this.props.orientation && this.props.carouselStore.setStoreState({
          isPageScrollLocked: !1
        }), this.setState({
          deltaX: 0,
          deltaY: 0,
          isBeingTouchDragged: !1,
          isBeingMouseDragged: !1
        }), this.isDocumentScrolling = !this.props.lockOnWindowScroll && null;
      }
    }, {
      key: "callCallback",
      value: function value(e, t) {
        var r = this.props.trayProps;
        r && "function" == typeof r[e] && (t.persist(), r[e](t));
      }
    }, {
      key: "handleOnMouseDown",
      value: function value(e) {
        if (!this.props.dragEnabled) return void this.callCallback("onMouseDown", e);
        e.preventDefault(), this.fakeOnDragStart({
          screenX: e.screenX,
          screenY: e.screenY,
          mouseDrag: !0
        }), this.callCallback("onMouseDown", e);
      }
    }, {
      key: "handleOnMouseMove",
      value: function value(e) {
        this.state.isBeingMouseDragged && (this.setState({
          cancelNextClick: !0
        }), e.preventDefault(), this.fakeOnDragMove(e.screenX, e.screenY));
      }
    }, {
      key: "handleOnMouseUp",
      value: function value(e) {
        this.state.isBeingMouseDragged && (e.preventDefault(), this.fakeOnDragEnd());
      }
    }, {
      key: "handleOnClickCapture",
      value: function value(e) {
        if (!this.state.cancelNextClick) return void this.callCallback("onClickCapture", e);
        e.preventDefault(), this.setState({
          cancelNextClick: !1
        }), this.callCallback("onClickCapture", e);
      }
    }, {
      key: "handleOnTouchStart",
      value: function value(e) {
        if (!this.props.touchEnabled) return void this.callCallback("onTouchStart", e);
        "vertical" === this.props.orientation && e.preventDefault();
        var t = e.targetTouches[0];
        this.fakeOnDragStart({
          screenX: t.screenX,
          screenY: t.screenY,
          touchDrag: !0
        }), this.callCallback("onTouchStart", e);
      }
    }, {
      key: "handleDocumentScroll",
      value: function value() {
        var e = this;
        this.props.touchEnabled && (this.isDocumentScrolling = !0, window.clearTimeout(this.scrollStopTimer), this.scrollStopTimer = window.setTimeout(function () {
          e.isDocumentScrolling = !1;
        }, 66));
      }
    }, {
      key: "handleOnTouchMove",
      value: function value(e) {
        if (!this.props.touchEnabled || this.props.lockOnWindowScroll && this.isDocumentScrolling) return void this.callCallback("onTouchMove", e);
        window.cancelAnimationFrame.call(window, this.moveTimer);
        var t = e.targetTouches[0];
        t && (this.fakeOnDragMove(t.screenX, t.screenY), this.callCallback("onTouchMove", e));
      }
    }, {
      key: "forward",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.step,
          i = e.totalSlides,
          n = e.visibleSlides;
        return Math.min(t + r, i - n);
      }
    }, {
      key: "backward",
      value: function value() {
        var e = this.props,
          t = e.currentSlide,
          r = e.step;
        return Math.max(t - r, 0);
      }
    }, {
      key: "handleOnKeyDown",
      value: function value(e) {
        var t = e.keyCode,
          r = this.props,
          i = r.carouselStore,
          n = r.currentSlide,
          s = r.disableKeyboard,
          o = r.totalSlides,
          a = r.visibleSlides,
          l = {};
        !0 === s || o <= a || (37 === t && (e.preventDefault(), this.focus(), l.currentSlide = Math.max(0, n - 1), l.isPlaying = !1), 39 === t && (e.preventDefault(), this.focus(), l.currentSlide = Math.min(o - a, n + 1), l.isPlaying = !1), i.setStoreState(l));
      }
    }, {
      key: "playForward",
      value: function value() {
        var e = this.props,
          t = e.carouselStore,
          r = e.currentSlide;
        t.setStoreState({
          currentSlide: this.forward() === r ? 0 : this.forward()
        });
      }
    }, {
      key: "playBackward",
      value: function value() {
        var e = this.props,
          t = e.carouselStore,
          r = e.currentSlide,
          i = e.totalSlides,
          n = e.visibleSlides;
        t.setStoreState({
          currentSlide: this.backward() === r ? i - n : this.backward()
        });
      }
    }, {
      key: "play",
      value: function value() {
        var e = this.props.playDirection;
        this.interval = setInterval("forward" === e ? this.playForward : this.playBackward, this.props.interval);
      }
    }, {
      key: "stop",
      value: function value() {
        window.clearInterval(this.interval), this.interval = null;
      }
    }, {
      key: "lockScroll",
      value: function value() {
        var e = new GetScrollParent();
        this.scrollParent = e.getScrollParent(this.sliderTrayElement), this.scrollParent && (this.originalOverflow = this.originalOverflow || this.scrollParent.style.overflow, this.scrollParent.style.overflow = "hidden");
      }
    }, {
      key: "unlockScroll",
      value: function value() {
        this.scrollParent && (this.scrollParent.style.overflow = this.originalOverflow, this.originalOverflow = null, this.scrollParent = null);
      }
    }, {
      key: "blockWindowScroll",
      value: function value(e) {
        this.state.preventingVerticalScroll && (e.preventDefault(), e.stopImmediatePropagation());
      }
    }, {
      key: "computeCurrentSlide",
      value: function value() {
        var e = t.slideSizeInPx(this.props.orientation, this.sliderTrayElement.clientWidth, this.sliderTrayElement.clientHeight, this.props.totalSlides),
          r = t.slidesMoved(this.props.moveThreshold, this.props.orientation, this.state.deltaX, this.state.deltaY, e, this.props.dragStep),
          i = this.props.totalSlides - Math.min(this.props.totalSlides, this.props.visibleSlides),
          n = boundedRange({
            min: 0,
            max: i,
            x: this.props.currentSlide + r
          });
        this.props.infinite && (this.props.currentSlide >= i && r > 0 && (n = 0), 0 === this.props.currentSlide && r < 0 && (n = i)), this.props.carouselStore.setStoreState({
          currentSlide: n
        });
      }
    }, {
      key: "focus",
      value: function value() {
        this.sliderElement.focus();
      }
    }, {
      key: "handleOnTouchEnd",
      value: function value(e) {
        this.endTouchMove(), this.callCallback("onTouchEnd", e);
      }
    }, {
      key: "handleOnTouchCancel",
      value: function value(e) {
        this.endTouchMove(), this.callCallback("onTouchCancel", e);
      }
    }, {
      key: "endTouchMove",
      value: function value() {
        this.props.touchEnabled && this.fakeOnDragEnd();
      }
    }, {
      key: "renderMasterSpinner",
      value: function value() {
        var e = this.props,
          t = e.hasMasterSpinner,
          r = e.masterSpinnerFinished,
          i = e.spinner;
        return t && !r ? ("function" == typeof this.props.onMasterSpinner && this.props.onMasterSpinner(), /*#__PURE__*/React.createElement("div", {
          className: cn([s$b.masterSpinnerContainer, "carousel__master-spinner-container"])
        }, i && i(), !i && /*#__PURE__*/React.createElement(Spinner, null))) : null;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
          t = this.props,
          r = t.ariaLabel,
          i = (t.carouselStore, t.children),
          n = t.className,
          s = t.classNameAnimation,
          o = t.classNameTray,
          a = t.classNameTrayWrap,
          l = t.currentSlide,
          c = t.disableAnimation,
          u = (t.disableKeyboard, t.dragEnabled, t.hasMasterSpinner, t.interval, t.isPageScrollLocked, t.isPlaying, t.lockOnWindowScroll, t.masterSpinnerFinished, t.moveThreshold, t.naturalSlideHeight),
          p = t.naturalSlideWidth,
          d = (t.onMasterSpinner, t.orientation),
          h = (t.playDirection, t.privateUnDisableAnimation, t.slideSize),
          S = t.slideTraySize,
          y = (t.spinner, t.style),
          b = t.tabIndex,
          m = (t.totalSlides, t.touchEnabled, t.trayProps),
          f = t.trayTag,
          g = t.visibleSlides,
          v = t.isIntrinsicHeight,
          _ = _objectWithoutProperties(t, _excluded$c$1),
          T = _extends({}, y),
          k = {};
        "vertical" === d && (k.height = 0, k.paddingBottom = pct(100 * u * g / p), k.width = pct(100));
        var C = {},
          O = pct(h * l * -1);
        (this.state.isBeingTouchDragged || this.state.isBeingMouseDragged || c) && (C.transition = "none"), v && (C.display = "flex", C.alignItems = "stretch"), "vertical" === d ? (C.transform = "translateY(".concat(O, ") translateY(").concat(this.state.deltaY, "px)"), C.width = pct(100), C.flexDirection = "column") : (C.width = pct(S), C.transform = "translateX(".concat(O, ") translateX(").concat(this.state.deltaX, "px)"), C.flexDirection = "row");
        var P = cn(["vertical" === d ? s$b.verticalSlider : s$b.horizontalSlider, "carousel__slider", "vertical" === d ? "carousel__slider--vertical" : "carousel__slider--horizontal", n]),
          E = cn([s$b.sliderTrayWrap, "carousel__slider-tray-wrapper", "vertical" === d ? s$b.verticalSlideTrayWrap : s$b.horizontalTrayWrap, "vertical" === d ? "carousel__slider-tray-wrap--vertical" : "carousel__slider-tray-wrap--horizontal", a]),
          w = cn([s$b.sliderTray, s || s$b.sliderAnimation, "carousel__slider-tray", "vertical" === d ? s$b.verticalTray : s$b.horizontalTray, "vertical" === d ? "carousel__slider-tray--vertical" : "carousel__slider-tray--horizontal", o]),
          M = null !== b ? b : 0,
          x = (_.dragStep, _.step, _.infinite, _.preventVerticalScrollOnTouch, _.preventingVerticalScroll, _.horizontalPixelThreshold, _.verticalPixelThreshold, _objectWithoutProperties(_, _excluded2$2)),
          R = (m.className, m.onClickCapture, m.onMouseDown, m.onTouchCancel, m.onTouchEnd, m.onTouchMove, m.onTouchStart, m.ref, m.style, _objectWithoutProperties(m, _excluded3));
        return /*#__PURE__*/React.createElement("div", _extends({
          ref: function ref(t) {
            e.sliderElement = t;
          },
          className: P,
          "aria-live": "polite",
          "aria-label": r,
          style: T,
          tabIndex: M,
          onKeyDown: this.handleOnKeyDown,
          role: "listbox"
        }, x), /*#__PURE__*/React.createElement("div", {
          className: E,
          style: k
        }, /*#__PURE__*/React.createElement(f, _extends({
          ref: this.getSliderRef,
          className: w,
          style: C,
          onTouchStart: this.handleOnTouchStart,
          onTouchMove: this.handleOnTouchMove,
          onTouchEnd: this.handleOnTouchEnd,
          onTouchCancel: this.handleOnTouchCancel,
          onMouseDown: this.handleOnMouseDown,
          onClickCapture: this.handleOnClickCapture
        }, R), i), this.renderMasterSpinner()));
      }
    }], [{
      key: "slideSizeInPx",
      value: function value(e, t, r, i) {
        return ("horizontal" === e ? t : r) / i;
      }
    }, {
      key: "slidesMoved",
      value: function value(e, t, r, i, n, s) {
        var o = "horizontal" === t ? r : i,
          a = Math.abs(Math.round(o / n)),
          l = Math.abs(o) >= n * e ? s : 0,
          c = Math.max(l, a);
        if (o < 0) return c;
        var u = -c;
        return 0 === u ? 0 : u;
      }
    }]), t;
  }(React.Component), _defineProperty(_class$a, "propTypes", {
    ariaLabel: propTypes.string,
    carouselStore: propTypes.object.isRequired,
    children: propTypes.node.isRequired,
    className: propTypes.string,
    classNameAnimation: propTypes.string,
    classNameTray: propTypes.string,
    classNameTrayWrap: propTypes.string,
    currentSlide: propTypes.number.isRequired,
    disableAnimation: propTypes.bool,
    disableKeyboard: propTypes.bool,
    dragEnabled: propTypes.bool.isRequired,
    dragStep: propTypes.number,
    hasMasterSpinner: propTypes.bool.isRequired,
    infinite: propTypes.bool,
    interval: propTypes.number.isRequired,
    isPageScrollLocked: propTypes.bool.isRequired,
    isPlaying: propTypes.bool.isRequired,
    lockOnWindowScroll: propTypes.bool.isRequired,
    preventVerticalScrollOnTouch: propTypes.bool,
    horizontalPixelThreshold: propTypes.number,
    verticalPixelThreshold: propTypes.number,
    masterSpinnerFinished: propTypes.bool.isRequired,
    moveThreshold: propTypes.number,
    naturalSlideHeight: propTypes.number.isRequired,
    naturalSlideWidth: propTypes.number.isRequired,
    onMasterSpinner: propTypes.func,
    orientation: CarouselPropTypes.orientation.isRequired,
    playDirection: CarouselPropTypes.direction.isRequired,
    privateUnDisableAnimation: propTypes.bool,
    slideSize: propTypes.number.isRequired,
    slideTraySize: propTypes.number.isRequired,
    spinner: propTypes.func,
    step: propTypes.number.isRequired,
    style: propTypes.object,
    tabIndex: propTypes.number,
    totalSlides: propTypes.number.isRequired,
    touchEnabled: propTypes.bool.isRequired,
    trayProps: propTypes.shape({
      className: propTypes.string,
      onClickCapture: propTypes.func,
      onMouseDown: propTypes.func,
      onTouchCancel: propTypes.func,
      onTouchEnd: propTypes.func,
      onTouchMove: propTypes.func,
      onTouchStart: propTypes.func,
      ref: propTypes.shape({}),
      style: propTypes.string
    }),
    trayTag: propTypes.string,
    visibleSlides: propTypes.number,
    isIntrinsicHeight: propTypes.bool
  }), _defineProperty(_class$a, "defaultProps", {
    ariaLabel: "slider",
    className: null,
    classNameAnimation: null,
    classNameTray: null,
    classNameTrayWrap: null,
    disableAnimation: !1,
    disableKeyboard: !1,
    dragStep: 1,
    infinite: !1,
    preventVerticalScrollOnTouch: !0,
    horizontalPixelThreshold: 15,
    verticalPixelThreshold: 10,
    moveThreshold: .1,
    onMasterSpinner: null,
    privateUnDisableAnimation: !1,
    spinner: null,
    style: {},
    tabIndex: null,
    trayProps: {},
    trayTag: "div",
    visibleSlides: 1,
    isIntrinsicHeight: !1
  }), _class$a),
  index$8 = WithStore(Slider, function (e) {
    return {
      currentSlide: e.currentSlide,
      disableAnimation: e.disableAnimation,
      privateUnDisableAnimation: e.privateUnDisableAnimation,
      disableKeyboard: e.disableKeyboard,
      dragEnabled: e.dragEnabled,
      hasMasterSpinner: e.hasMasterSpinner,
      infinite: e.infinite,
      interval: e.interval,
      isPageScrollLocked: e.isPageScrollLocked,
      isPlaying: e.isPlaying,
      lockOnWindowScroll: e.lockOnWindowScroll,
      preventingVerticalScroll: e.preventingVerticalScroll,
      masterSpinnerFinished: e.masterSpinnerFinished,
      naturalSlideHeight: e.naturalSlideHeight,
      naturalSlideWidth: e.naturalSlideWidth,
      orientation: e.orientation,
      playDirection: e.playDirection,
      slideSize: e.slideSize,
      slideTraySize: e.slideTraySize,
      step: e.step,
      dragStep: e.dragStep,
      totalSlides: e.totalSlides,
      touchEnabled: e.touchEnabled,
      visibleSlides: e.visibleSlides,
      isIntrinsicHeight: e.isIntrinsicHeight
    };
  });

// import { pickDomAttributes } from '@bgea-js/react-utilities';
// import { useRef } from 'react';
// import Slider from 'react-slick';
/* eslint import/no-unassigned-import: "off" */
var Carousel = function Carousel(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? [] : _ref$content,
    _ref$provider = _ref.provider,
    provider = _ref$provider === void 0 ? {
      naturalSlideWidth: 100,
      naturalSlideHeight: 100,
      totalSlides: content.length
    } : _ref$provider;
  return jsxs(CarouselProvider, {
    naturalSlideWidth: provider.naturalSlideWidth,
    naturalSlideHeight: provider.naturalSlideHeight,
    isIntrinsicHeight: true,
    totalSlides: provider.totalSlides
    // infinite
    // orientation="horizontal"
    // interval={2000}
    // isPlaying
    ,
    children: [jsx(index$8, {
      children: content.map(function (item, i) {
        return jsx(index$7, {
          index: i,
          children: item.slide
        }, "HPCS");
      })
    }), jsx(Columns, {
      children: content.map(function (item, i) {
        return jsx(Columns.Column, {
          children: jsx(Dot$1, {
            slide: i,
            className: "",
            children: item.nav
          })
        }, "c");
      })
    })]
  });
};

var _excluded$k = ["title", "description", "img"];
var ContentCard = function ContentCard(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$img = _ref.img,
    img = _ref$img === void 0 ? '' : _ref$img,
    props = _objectWithoutProperties$1(_ref, _excluded$k);
  var domAttributes = pickDomAttributes(props);
  return jsxs("div", _objectSpread2$1(_objectSpread2$1({
    className: "card"
  }, domAttributes), {}, {
    children: [jsx("div", {
      className: "card-image",
      children: jsx("figure", {
        className: "image is-4by3",
        children: jsx("img", {
          src: img,
          alt: "Placeholder"
        })
      })
    }), jsxs("div", {
      className: "card-content",
      children: [jsx("div", {
        className: "media",
        children: jsx("div", {
          className: "media-content",
          children: jsx("p", {
            className: "title is-4",
            children: title
          })
        })
      }), jsx("div", {
        className: "content",
        children: description
      })]
    })]
  }));
};
ContentCard.propTypes = {
  description: PropTypes.string,
  img: PropTypes.string,
  title: PropTypes.string
};

/* eslint-disable camelcase */

function setEchoVars(echoTenant, echoUuid) {
  window.echo_tenant = echoTenant;
  window.echo_uuid = echoUuid;
}
var EchoChat = function EchoChat(_ref) {
  var _ref$echoTenant = _ref.echoTenant,
    echoTenant = _ref$echoTenant === void 0 ? 'bgea.echoglobal.org' : _ref$echoTenant,
    _ref$echoUuid = _ref.echoUuid,
    echoUuid = _ref$echoUuid === void 0 ? '3961cd4b-3ed1-4e72-b08e-60c8313f356b' : _ref$echoUuid;
  setEchoVars(echoTenant, echoUuid);
  useScript({
    url: "https://bgea.echoglobal.org/client/websites/full_frame_widget.js?v=3"
  });
  return jsx("div", {
    className: "js-widget echo-chat-widget"
  });
};

var MenuLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e1aj5bk70"
} : {
  target: "e1aj5bk70",
  label: "MenuLink"
})("display:block;text-decoration:none;margin-bottom:1.5rem;font-size:1rem;color:", function (props) {
  return props.color || '#161f28';
}, ";transition:color 0.2s;font-weight:bold;text-transform:uppercase;letter-spacing:1px;font-family:p22-mackinac-pro,serif;&:hover{color:", function (props) {
  return props.hoverColor || '#f37755';
}, ";}span{margin-left:7.8rem;}button{border:0;border-radius:0.25rem;font-family:proxima-nova,sans-serif;background-color:#fff;color:#578fc8;font-size:1.2rem;font-weight:600;line-height:1.2;white-space:nowrap;text-decoration:none;padding:0.25rem 0.5rem;margin:0 0 0 6.5rem;cursor:pointer;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var MenuItemOnClick = function MenuItemOnClick(_ref) {
  var item = _ref.item,
    menuLinkColor = _ref.menuLinkColor,
    menuLinkHoverColor = _ref.menuLinkHoverColor,
    handleOnClick = _ref.handleOnClick;
  return jsxs(MenuLink, {
    color: menuLinkColor,
    hoverColor: menuLinkHoverColor,
    onClick: handleOnClick,
    children: [item.label, " ", jsx("button", {
      type: "button",
      children: "+"
    })]
  });
};
var MobileMenuItemLink = function MobileMenuItemLink(_ref2) {
  var _item$items;
  var item = _ref2.item,
    _ref2$menuLinkColor = _ref2.menuLinkColor,
    menuLinkColor = _ref2$menuLinkColor === void 0 ? '#161f28' : _ref2$menuLinkColor,
    _ref2$menuLinkHoverCo = _ref2.menuLinkHoverColor,
    menuLinkHoverColor = _ref2$menuLinkHoverCo === void 0 ? '#f37755' : _ref2$menuLinkHoverCo,
    handleOnClick = _ref2.handleOnClick;
  var hasSubMenu = (item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length) > 0;
  return !hasSubMenu ? jsx(MenuLink, {
    color: menuLinkColor,
    hoverColor: menuLinkHoverColor,
    href: item.href,
    children: item.label
  }) : jsx(MenuItemOnClick, {
    item: item,
    menuLinkColor: menuLinkColor,
    menuLinkHoverColor: menuLinkHoverColor,
    handleOnClick: handleOnClick
  });
};

var _excluded$j = ["items"];
var MobileSubNav = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eumh66w0"
} : {
  target: "eumh66w0",
  label: "MobileSubNav"
})("display:flex!important;flex-direction:column;background-color:#f3f3f3;padding:0.5rem 1rem;a{margin:0.5rem 0;color:", function (props) {
  return props.color || '#4491ce';
}, ";font-size:0.9rem;}h2{text-transform:none;font-size:0.8rem;margin:0.5rem 0;border-bottom:2px solid #f37755;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1vYmlsZVN1Yk1lbnUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWU0QyIsImZpbGUiOiJNb2JpbGVTdWJNZW51LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgTmF2TGlzdEl0ZW0gfSBmcm9tICcuL01vYmlsZU1lbnUnO1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IE1vYmlsZU1lbnVJdGVtTGluayB9IGZyb20gJy4vTW9iaWxlTWVudUl0ZW1MaW5rJztcblxuaW50ZXJmYWNlIFN0eWxlZFByb3BzIHtcbiAgY29sb3I/OiBzdHJpbmc7XG59XG5cbmludGVyZmFjZSBQcm9wcyB7XG4gIGl0ZW1zOiBOYXZMaXN0SXRlbVtdO1xuICBzdWJNZW51Q29sb3I/OiBzdHJpbmc7XG59XG5cbmNvbnN0IE1vYmlsZVN1Yk5hdiA9IHN0eWxlZC5kaXY8U3R5bGVkUHJvcHM+YFxuICBkaXNwbGF5OiBmbGV4ICFpbXBvcnRhbnQ7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGJhY2tncm91bmQtY29sb3I6ICNmM2YzZjM7XG4gIHBhZGRpbmc6IDAuNXJlbSAxcmVtO1xuXG4gIGEge1xuICAgIG1hcmdpbjogMC41cmVtIDA7XG4gICAgY29sb3I6ICR7KHByb3BzKSA9PiBwcm9wcy5jb2xvciB8fCAnIzQ0OTFjZSd9O1xuICAgIGZvbnQtc2l6ZTogMC45cmVtO1xuICB9XG5cbiAgaDIge1xuICAgIHRleHQtdHJhbnNmb3JtOiBub25lO1xuICAgIGZvbnQtc2l6ZTogMC44cmVtO1xuICAgIG1hcmdpbjogMC41cmVtIDA7XG4gICAgYm9yZGVyLWJvdHRvbTogMnB4IHNvbGlkICNmMzc3NTU7XG4gIH1cbmA7XG5cbmV4cG9ydCBjb25zdCBNb2JpbGVTdWJNZW51ID0gKHsgaXRlbXMsIC4uLnByb3BzIH06IFByb3BzKSA9PiB7XG4gIGNvbnN0IGhhc1N1Yk1lbnUgPSBpdGVtcz8ubGVuZ3RoID4gMDtcbiAgaWYgKCFoYXNTdWJNZW51KSB7XG4gICAgcmV0dXJuIG51bGw7XG4gIH1cblxuICByZXR1cm4gKFxuICAgIDxNb2JpbGVTdWJOYXYgY29sb3I9e3Byb3BzPy5zdWJNZW51Q29sb3J9PlxuICAgICAge2l0ZW1zPy5tYXAoKGl0ZW0pID0+IChcbiAgICAgICAgPE1vYmlsZU1lbnVJdGVtTGluayBrZXk9e2l0ZW0ubGFiZWx9IGl0ZW09e2l0ZW19IHsuLi5wcm9wc30gLz5cbiAgICAgICkpfVxuICAgIDwvTW9iaWxlU3ViTmF2PlxuICApO1xufTtcbiJdfQ== */"));
var MobileSubMenu = function MobileSubMenu(_ref) {
  var items = _ref.items,
    props = _objectWithoutProperties$1(_ref, _excluded$j);
  var hasSubMenu = (items === null || items === void 0 ? void 0 : items.length) > 0;
  if (!hasSubMenu) {
    return null;
  }
  return jsx(MobileSubNav, {
    color: props === null || props === void 0 ? void 0 : props.subMenuColor,
    children: items === null || items === void 0 ? void 0 : items.map(function (item) {
      return jsx(MobileMenuItemLink, _objectSpread2$1({
        item: item
      }, props), item.label);
    })
  });
};

var _excluded$i = ["item"];
var MobileMenuItem = function MobileMenuItem(_ref) {
  var _item$items;
  var item = _ref.item,
    props = _objectWithoutProperties$1(_ref, _excluded$i);
  var hasSubMenu = (item === null || item === void 0 ? void 0 : (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.length) > 0;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubMenuOpen = _useState2[0],
    setIsSubMenuOpen = _useState2[1];
  var handleOnClick = function handleOnClick() {
    return setIsSubMenuOpen(!isSubMenuOpen);
  };
  return jsx(Fragment, {
    children: !hasSubMenu ? jsx(MobileMenuItemLink, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
      item: item
    })) : jsxs(Fragment, {
      children: [jsx(MobileMenuItemLink, _objectSpread2$1({
        item: item,
        handleOnClick: handleOnClick
      }, props)), isSubMenuOpen && jsx(MobileSubMenu, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
        items: item.items
      }))]
    })
  });
};

var MobileMenu = function MobileMenu(_ref) {
  var props = _extends$1({}, (_objectDestructuringEmpty(_ref), _ref));
  var items = props.items;
  return jsx(slide, _objectSpread2$1(_objectSpread2$1({
    right: true
  }, props), {}, {
    children: items.map(function (item) {
      return jsx(MobileMenuItem, _objectSpread2$1(_objectSpread2$1({}, props), {}, {
        item: item
      }), item.label);
    })
  }));
};

var NavbarGlobal = function NavbarGlobal(_ref) {
  var brand = _ref.brand,
    items = _ref.items;
  return jsxs(Navbar, {
    color: "black",
    id: "NavbarGlobal",
    children: [jsx(Navbar.Brand, {
      children: jsx(Navbar.Item, {
        href: brand.href,
        renderAs: "a",
        children: brand.label
      })
    }), jsx(Navbar.Container, {
      align: "left",
      children: items.map(function (item) {
        return jsx(Navbar.Item, {
          href: item.href,
          renderAs: "a",
          className: "is-uppercase has-text-weight-semibold is-size-7",
          children: item.label
        }, item.title);
      })
    }), jsx(Navbar.Container, {
      align: "right",
      children: jsx(Navbar.Item, {
        href: "/",
        renderAs: "a",
        className: "is-uppercase has-text-weight-semibold is-size-7",
        children: "More"
      })
    })]
  });
};

var SubNav = function SubNav(_ref) {
  var feature = _ref.feature,
    items = _ref.items;
  var columnSize = 3;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var toggleActive = function toggleActive(key) {
    if (active.includes(key)) {
      setActive(active.filter(function (v) {
        return v !== key;
      }));
    } else {
      setActive([].concat(_toConsumableArray$1(active), [key]));
    }
  };
  return jsxs(Navbar.Dropdown, {
    children: [jsx(Container, {
      className: "is-hidden-mobile",
      children: jsxs(Columns, {
        children: [jsx(Columns.Column, {
          size: columnSize,
          children: jsxs(Content$1, {
            className: "is-mega-menu-content",
            children: [jsx("h1", {
              className: "title is-6 mb-0",
              children: feature.label
            }), jsx("img", {
              src: "https://picsum.photos/800/300?blur=1&x=10&".concat(feature.label)
            }), jsx("p", {
              children: feature.description
            })]
          })
        }), jsx(Columns.Column, {
          children: jsx(Columns, {
            children: items && items.map(function (item) {
              return jsxs(Columns.Column, {
                children: [jsx("h1", {
                  className: "title is-6 is-mega-menu-title is-underlined",
                  children: item.label
                }), item.children.map(function (child) {
                  return jsx(Navbar.Item, {
                    href: "#",
                    children: child.label
                  }, child.label);
                })]
              }, item.label);
            })
          })
        })]
      })
    }), jsx("div", {
      className: "is-hidden-desktop",
      children: items && items.map(function (item, i) {
        return jsxs(Navbar.Item, {
          active: active.includes(i),
          children: [jsx(Navbar.Link, {
            onClick: function onClick() {
              return toggleActive(i);
            },
            children: item.label
          }), jsx(Navbar.Dropdown, {
            children: item.children.map(function (child) {
              return jsx(Navbar.Item, {
                href: "#",
                children: child.label
              }, child.label);
            })
          })]
        }, item.label);
      })
    })]
  });
};

var NavbarPrimary = function NavbarPrimary(_ref) {
  var brand = _ref.brand,
    navigation = _ref.navigation;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    activeNav = _useState4[0],
    setActiveNav = _useState4[1];
  var toggleActive = function toggleActive() {
    setActive(!active);
  };
  var toggleActiveNav = function toggleActiveNav(key) {
    setActiveNav(function (prev) {
      // eslint-disable-next-line eqeqeq
      return prev == key ? null : key;
    });
  };
  var ref = useDetectClickOutside({
    onTriggered: toggleActiveNav
  });
  return jsx("div", {
    ref: ref,
    children: jsxs(Navbar, {
      active: active,
      children: [jsxs(Navbar.Brand, {
        children: [brand && jsx("a", {
          className: "navbar-item is-hidden-desktops",
          href: brand.href,
          children: brand.logo
        }), jsx(Navbar.Burger, {
          onClick: toggleActive
        })]
      }), jsxs(Navbar.Menu, {
        children: [jsx(Navbar.Container, {
          align: "right",
          children: navigation && navigation.map(function (item) {
            return jsxs(Navbar.Item, {
              // href="#"
              renderAs: "div",
              className: "is-mega has-dropdown",
              onClick: function onClick() {
                return toggleActiveNav(item.label);
              },
              active: item.label === activeNav,
              children: [jsx(Navbar.Link, {
                children: item.label
              }), jsx(SubNav, {
                items: item.items,
                feature: item.feature
              })]
            }, item.label);
          })
        }), jsxs(Navbar.Container, {
          align: "right",
          children: [jsxs(Navbar.Item, {
            href: "/",
            renderAs: "a",
            hoverable: true,
            className: "is-mega",
            children: [jsx(Navbar.Link, {
              children: "Search"
            }), jsx(Navbar.Dropdown, {
              children: jsx(Container, {
                className: "is-centered has-text-centered",
                children: jsxs("div", {
                  className: "field has-addons is-justify-content-center is-large",
                  children: [jsx("div", {
                    className: "control",
                    children: jsx("input", {
                      className: "input is-large",
                      type: "text",
                      placeholder: "Search the site"
                    })
                  }), jsx("div", {
                    className: "control",
                    children: jsx("a", {
                      className: "button is-large is-info",
                      children: "Search"
                    })
                  })]
                })
              })
            })]
          }), jsx(Navbar.Item, {
            href: "/",
            renderAs: "a",
            children: jsx(Button$1, {
              color: "primary",
              children: "Give"
            })
          })]
        })]
      })]
    })
  });
};

// import * as colors from '@bgea-js/colors';
var borderWidth = '2px';
var borderColor = '#ddd';
var NavbarSecondaryContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1q63b970"
} : {
  target: "e1q63b970",
  label: "NavbarSecondaryContainer"
})("nav{border-top:", borderWidth, " solid ", borderColor, ";border-bottom:", borderWidth, " solid ", borderColor, ";.navbar-brand,.navbar-start .navbar-item{letter-spacing:1.1px;}}", mediaQueries.forDesktopUp, "{.navbar-brand,.navbar-start .navbar-item{border-right:", borderWidth, " solid ", borderColor, ";min-height:2.5rem;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT3VEIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG4vLyBpbXBvcnQgeyBIZXJvIH0gZnJvbSAnQGJnZWEtanMvcmVhY3QtdWknO1xuaW1wb3J0IHsgbWVkaWFRdWVyaWVzIH0gZnJvbSAnQGJnZWEtanMvcmVhY3QtdXRpbGl0aWVzJztcbi8vIGltcG9ydCAqIGFzIGNvbG9ycyBmcm9tICdAYmdlYS1qcy9jb2xvcnMnO1xuY29uc3QgYm9yZGVyV2lkdGggPSAnMnB4JztcbmNvbnN0IGJvcmRlckNvbG9yID0gJyNkZGQnO1xuXG5leHBvcnQgY29uc3QgTmF2YmFyU2Vjb25kYXJ5Q29udGFpbmVyID0gc3R5bGVkLmRpdjxhbnk+YFxuICBuYXYge1xuICAgIGJvcmRlci10b3A6ICR7Ym9yZGVyV2lkdGh9IHNvbGlkICR7Ym9yZGVyQ29sb3J9O1xuICAgIGJvcmRlci1ib3R0b206ICR7Ym9yZGVyV2lkdGh9IHNvbGlkICR7Ym9yZGVyQ29sb3J9O1xuICAgIC5uYXZiYXItYnJhbmQsXG4gICAgLm5hdmJhci1zdGFydCAubmF2YmFyLWl0ZW0ge1xuICAgICAgbGV0dGVyLXNwYWNpbmc6IDEuMXB4O1xuICAgIH1cbiAgfVxuICAke21lZGlhUXVlcmllcy5mb3JEZXNrdG9wVXB9IHtcbiAgICAubmF2YmFyLWJyYW5kLFxuICAgIC5uYXZiYXItc3RhcnQgLm5hdmJhci1pdGVtIHtcbiAgICAgIGJvcmRlci1yaWdodDogJHtib3JkZXJXaWR0aH0gc29saWQgJHtib3JkZXJDb2xvcn07XG4gICAgICBtaW4taGVpZ2h0OiAyLjVyZW07XG4gICAgfVxuICB9XG5gO1xuIl19 */"));

var NavbarSecondary = function NavbarSecondary(_ref) {
  var brand = _ref.brand,
    items = _ref.items;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var toggleActive = function toggleActive() {
    setActive(!active);
  };
  return jsx(NavbarSecondaryContainer, {
    children: jsx(Navbar, {
      active: active,
      children: jsxs(Container, {
        children: [jsxs(Navbar.Brand, {
          children: [jsx(Navbar.Item, {
            href: brand.href,
            renderAs: "a",
            children: brand.label
          }), jsx(Navbar.Burger, {
            onClick: toggleActive
          })]
        }), jsx(Navbar.Menu, {
          children: jsx(Navbar.Container, {
            align: "left",
            children: items.map(function (item) {
              return jsx(Navbar.Item, {
                href: item.href,
                renderAs: "a",
                className: "is-uppercase has-text-weight-semibold is-size-7",
                children: item.label
              }, item.title);
            })
          })
        })]
      })
    })
  });
};

var _excluded$h = ["id", "type", "align", "size", "fullwidth", "content"];
var Tabs = function Tabs(_ref) {
  var id = _ref.id,
    type = _ref.type,
    align = _ref.align,
    size = _ref.size,
    fullwidth = _ref.fullwidth,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? [] : _ref$content,
    props = _objectWithoutProperties$1(_ref, _excluded$h);
  var domAttributes = pickDomAttributes(props);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  return jsxs("section", {
    children: [jsx(Tabs$1, _objectSpread2$1(_objectSpread2$1({
      id: id,
      type: type,
      align: align,
      size: size,
      fullwidth: fullwidth
    }, domAttributes), {}, {
      children: content.map(function (item, i) {
        var active = i === activeTab;
        return jsx(Tabs$1.Tab, {
          active: active,
          onClick: function onClick() {
            return setActiveTab(i);
          },
          onKeyDown: function onKeyDown() {
            return setActiveTab(i);
          },
          href: item.link ? item.link : '#',
          children: jsx("span", {
            lang: item === null || item === void 0 ? void 0 : item.lang,
            children: item.label
          })
        }, item.label);
      })
    })), jsx("div", {
      className: "content",
      children: content[activeTab].content
    })]
  });
};

var _excluded$g = ["dataUrl", "name", "options"];
// import type { DomAttributeProps } from '@bgea-js/react-utilities';

// import React, { useState, useEffect } from 'react';

var AudioPlayer = function AudioPlayer(_ref) {
  var dataUrl = _ref.dataUrl;
    _ref.name;
    _ref.options;
    var props = _objectWithoutProperties$1(_ref, _excluded$g);
  return jsx("section", {
    children: jsxs("audio", {
      controls: true,
      children: [jsx("track", _objectSpread2$1({
        kind: "captions"
      }, props)), jsx("source", {
        src: dataUrl,
        type: "audio/mpeg"
      }, dataUrl), "Your browser does not support the audio element."]
    }, dataUrl)
  });
};

// import type { DomAttributeProps } from '@bgea-js/react-utilities';

var VideoPlayer = function VideoPlayer(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? '530789341' : _ref$id;
  return jsx("section", {
    className: "kParent",
    children: jsx("div", {
      id: "kaltura_player_".concat(id),
      className: "kaltura-player"
    })
  });
};
VideoPlayer.propTypes = {
  id: PropTypes.string
};

var Playlist = function Playlist(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    changeActiveMedia = _ref.changeActiveMedia;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeMedia = _useState2[0],
    setActiveMedia = _useState2[1];
  var changeMedia = function changeMedia(i) {
    setActiveMedia(i);
    changeActiveMedia(items[i]);
  };
  return jsx("div", {
    children: items.map(function (item, i) {
      return jsxs("div", {
        onClick: function onClick() {
          return changeMedia(i);
        },
        onKeyDown: function onKeyDown() {
          return changeMedia(i);
        },
        role: "menuitem",
        tabIndex: 0,
        children: [i === activeMedia && jsx("div", {
          children: "THIS IS THE ACTIVE ONE"
        }), jsx("img", {
          src: item.thumbnailUrl,
          alt: item.name
        }), jsx("div", {
          children: item.name
        }), jsx("div", {
          children: item.description
        }), jsx("hr", {})]
      }, "");
    })
  });
};
Playlist.propTypes = {
  changeActiveMedia: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    name: PropTypes.string,
    thumbnailUrl: PropTypes.string
  }))
};

var _excluded$f = ["id", "ids"];
var getEntry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var id,
      url,
      response,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          id = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
          url = "https://www.kaltura.com/api_v3/service/media/action/get?entryId=".concat(id, "&format=1"); // TODO: Replace with react-query
          _context.next = 4;
          return fetch(url);
        case 4:
          response = _context.sent;
          return _context.abrupt("return", response.json());
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getEntry() {
    return _ref.apply(this, arguments);
  };
}();
var getEntries = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var ids,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          ids = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [''];
          return _context2.abrupt("return", ids.map(function (id) {
            return getEntry(id);
          }));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getEntries() {
    return _ref2.apply(this, arguments);
  };
}();

/* 
This component displays a video or audio player depending on the kaltura ID that is passed into the component
*/
var Kaltura = function Kaltura(_ref3) {
  var _ref3$id = _ref3.id,
    id = _ref3$id === void 0 ? '' : _ref3$id,
    _ref3$ids = _ref3.ids,
    ids = _ref3$ids === void 0 ? [''] : _ref3$ids,
    props = _objectWithoutProperties$1(_ref3, _excluded$f);
  var domAttributes = pickDomAttributes(props);
  if (!id && ids.length > 0) {
    // eslint-disable-next-line no-param-reassign
    var _ids = _slicedToArray(ids, 1);
    id = _ids[0];
  }
  var _useState = useState({
      loading: true,
      mediaType: null,
      dataUrl: null,
      options: null,
      audioActive: id,
      // The ID of the active audio that the user wants to listen to
      videoActive: id,
      // The ID of the active video that the user wants to see
      newData: null,
      activeIndex: 0,
      kalturaPlayer: 0,
      top: false,
      mixMatch: false,
      thumbnail: '',
      name: '',
      isLive: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    player = _useState2[0],
    setPlayer = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    playlist = _useState4[0],
    setPlaylist = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    kalturaPlayer = _useState6[0],
    setKalturaPlayer = _useState6[1];
  var initializeKalturaPlayer = function initializeKalturaPlayer() {
    var script = document.createElement('script');
    script.src = 'https://cdnapisec.kaltura.com/p/650742/embedPlaykitJs/uiconf_id/48174523';
    script.async = true;
    document.body.appendChild(script);
    script.onload = function () {
      // loads the kaltura player on the screeen
      try {
        var kalturaPlayerInstance = window.KalturaPlayer.setup({
          targetId: "kaltura_player_".concat(id),
          provider: {
            partnerId: 650742,
            uiConfId: 48174523
          }
        });
        setKalturaPlayer(kalturaPlayerInstance);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message);
      }
    };
  };
  var changeActiveMedia = function changeActiveMedia(data) {
    try {
      kalturaPlayer.loadMedia({
        // loads the video that corresponds to the ID that is active
        entryId: data.id
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e.message);
    }
    setPlayer(_objectSpread2$1(_objectSpread2$1({}, player), {}, {
      mediaType: data.mediaType,
      dataUrl: data.dataUrl,
      loading: false,
      name: data.name,
      thumbnail: data.thumbnailUrl
    }));
  };
  useEffect(function () {
    if (ids.length > 1) {
      getEntries(ids).then(function (a) {
        Promise.all(a).then(function (list) {
          // console.log("playlist)",list)
          setPlaylist(list);
        });
      });
    }
    if (typeof id === 'string') {
      getEntry(id).then(function (data) {
        if (data.mediaType === 1) {
          initializeKalturaPlayer();
          setPlayer(_objectSpread2$1(_objectSpread2$1({}, player), {}, {
            mediaType: data.mediaType,
            dataUrl: data.dataUrl,
            loading: false,
            name: data.name,
            thumbnail: data.thumbnailUrl
          }));
        }
        if (data.mediaType === 5) {
          setPlayer(_objectSpread2$1(_objectSpread2$1({}, player), {}, {
            mediaType: data.mediaType,
            dataUrl: data.dataUrl,
            loading: false,
            name: data.name
          }));
        }
        if (data.mediaType === 201) {
          initializeKalturaPlayer();
          setPlayer(_objectSpread2$1(_objectSpread2$1({}, player), {}, {
            mediaType: data.mediaType,
            dataUrl: data.dataUrl,
            loading: false,
            name: data.name,
            thumbnail: data.thumbnailUrl,
            isLive: data.liveStatus !== undefined && data.liveStatus !== 0
          }));
        }
      });
    }
  }, []);
  useEffect(function () {
    if (kalturaPlayer !== null) {
      kalturaPlayer.loadMedia({
        entryId: id
      });
    }
  }, [kalturaPlayer]);
  return jsxs("div", _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: [player.loading && jsx("p", {
      children: "loading..."
    }), !player.loading && jsxs("div", {
      children: [player.mediaType === 1 && jsx(VideoPlayer, {
        id: id
      }), player.mediaType === 5 && jsx(AudioPlayer, _objectSpread2$1({}, player)), player.mediaType === 201 && player.isLive && jsx(VideoPlayer, {
        id: id
      }), ids.length > 1 && jsx(Playlist, {
        items: playlist,
        changeActiveMedia: changeActiveMedia
      })]
    })]
  }));
};

var _excluded$e = ["heading", "description", "children", "reverse", "firstColumnWidth"];
var Callout = function Callout(_ref) {
  var heading = _ref.heading,
    description = _ref.description,
    children = _ref.children,
    reverse = _ref.reverse,
    _ref$firstColumnWidth = _ref.firstColumnWidth,
    firstColumnWidth = _ref$firstColumnWidth === void 0 ? 'one-third' : _ref$firstColumnWidth,
    props = _objectWithoutProperties$1(_ref, _excluded$e);
  var domAttributes = pickDomAttributes(props);
  return jsxs(Columns, _objectSpread2$1(_objectSpread2$1({
    className: reverse && 'reverse-row'
  }, domAttributes), {}, {
    children: [jsx(Columns.Column, {
      desktop: {
        size: firstColumnWidth
      },
      children: jsxs(Content$1, {
        className: "py-6",
        children: [jsx("h2", {
          children: heading
        }), jsx("hr", {
          className: "extend-right"
        }), jsx("p", {
          children: description
        })]
      })
    }), jsx(Columns.Column, {
      children: jsx(Content$1, {
        children: children
      })
    })]
  }));
};

var _excluded$d = ["heading", "content", "images", "reverse", "firstColumnWidth"];
var CalloutImage = function CalloutImage(_ref) {
  var heading = _ref.heading,
    content = _ref.content,
    images = _ref.images,
    reverse = _ref.reverse,
    _ref$firstColumnWidth = _ref.firstColumnWidth,
    firstColumnWidth = _ref$firstColumnWidth === void 0 ? 'one-third' : _ref$firstColumnWidth,
    props = _objectWithoutProperties$1(_ref, _excluded$d);
  var domAttributes = pickDomAttributes(props);
  return jsxs(Columns, _objectSpread2$1(_objectSpread2$1({
    className: reverse && 'reverse-row'
  }, domAttributes), {}, {
    children: [jsx(Columns.Column, {
      desktop: {
        size: firstColumnWidth
      },
      children: jsxs(Content$1, {
        className: "py-6",
        children: [jsx("h2", {
          children: heading
        }), jsx("hr", {
          className: "extend-right"
        }), jsx("p", {
          children: content
        })]
      })
    }), jsx(Columns.Column, {
      children: jsx(Content$1, {
        children: images && images.map(function (image) {
          return jsx("img", {
            src: image.url,
            alt: image.alt
          }, image.url);
        })
      })
    })]
  }));
};

var _excluded$c = ["title", "image", "description", "url"];
var CardContent = function CardContent(_ref) {
  var title = _ref.title,
    image = _ref.image,
    description = _ref.description,
    url = _ref.url,
    props = _objectWithoutProperties$1(_ref, _excluded$c);
  var domAttributes = pickDomAttributes(props);
  return jsx("a", _objectSpread2$1(_objectSpread2$1({
    href: url
  }, domAttributes), {}, {
    children: jsxs(Card, {
      className: "is-shadowless",
      children: [jsx(Card.Image, _objectSpread2$1({}, image)), jsxs(Card.Content, {
        className: "px-0",
        children: [jsx("span", {
          className: "has-text-weight-bold",
          children: title
        }), jsx("p", {
          children: description
        })]
      })]
    })
  }));
};

var _excluded$b = ["title", "image", "description", "footerLinks"];
var CardCTA = function CardCTA(_ref) {
  var title = _ref.title,
    image = _ref.image,
    description = _ref.description,
    footerLinks = _ref.footerLinks,
    props = _objectWithoutProperties$1(_ref, _excluded$b);
  var domAttributes = pickDomAttributes(props);
  return jsxs(Card, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: [jsx(Card.Header, {
      children: jsx("span", {
        className: "title has-text-weight-bold",
        children: title
      })
    }), jsx(Card.Image, _objectSpread2$1({}, image)), jsx(Card.Content, {
      children: jsx("p", {
        children: description
      })
    }), jsx(Card.Footer, {
      children: footerLinks && footerLinks.map(function (link) {
        return jsx(Card.Footer.Item, {
          children: jsxs("a", {
            href: link.url,
            children: [link.label, " ", jsx(ChevronRightIcon, {})]
          })
        }, link.url);
      })
    })]
  }));
};

var _excluded$a = ["src", "alt", "title", "caption"];
var Figure = function Figure(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    title = _ref.title,
    caption = _ref.caption,
    props = _objectWithoutProperties$1(_ref, _excluded$a);
  var domAttributes = pickDomAttributes(props);
  return jsxs("figure", _objectSpread2$1(_objectSpread2$1({
    title: title
  }, domAttributes), {}, {
    children: [jsx("img", {
      src: src,
      alt: alt,
      loading: "lazy"
    }), jsx("figcaption", {
      children: caption
    })]
  }));
};

var _excluded$9 = ["images"];
var Figures = function Figures(_ref) {
  var images = _ref.images,
    props = _objectWithoutProperties$1(_ref, _excluded$9);
  var domAttributes = pickDomAttributes(props);
  return jsx(Columns, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: images &&
    // eslint-disable-next-line array-callback-return, consistent-return
    images.map(function (image, i) {
      var _image$title;
      if (i <= 2) return jsx(Columns.Column, {
        children: jsx(Figure, _objectSpread2$1({}, image))
      }, image === null || image === void 0 ? void 0 : (_image$title = image.title) === null || _image$title === void 0 ? void 0 : _image$title.replace(' ', ''));
    })
  }));
};

var _excluded$8 = ["heading", "images"];
var ImageGallery = function ImageGallery(_ref) {
  var heading = _ref.heading,
    images = _ref.images,
    props = _objectWithoutProperties$1(_ref, _excluded$8);
  var domAttributes = pickDomAttributes(props);
  return jsxs(Content$1, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: [jsx("h1", {
      children: heading
    }), images && images.map(function (image, i) {
      var _image$title;
      var columnsclass = i % 2 ? 'is-vcentered is-desktop reverse-row' : 'is-vcentered is-desktop';
      return jsxs(Columns, {
        className: columnsclass,
        children: [jsx(Columns.Column, {
          children: jsx("img", {
            src: image.url,
            alt: image.alt
          }, image.url)
        }), jsxs(Columns.Column, {
          className: "",
          children: [jsx("p", {
            children: image.title
          }), jsx("p", {
            children: image.caption
          })]
        })]
      }, image === null || image === void 0 ? void 0 : (_image$title = image.title) === null || _image$title === void 0 ? void 0 : _image$title.replace(' ', ''));
    })]
  }));
};

var _excluded$7 = ["icon", "title", "description", "alignment"];
var Promo = function Promo(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'centered' : _ref$alignment,
    props = _objectWithoutProperties$1(_ref, _excluded$7);
  var domAttributes = pickDomAttributes(props);
  return jsxs("div", _objectSpread2$1(_objectSpread2$1({
    className: "block has-text-".concat(alignment)
  }, domAttributes), {}, {
    children: [jsx("div", {
      children: jsx(Icon, {
        children: icon
      })
    }), jsx("span", {
      children: title
    }), jsx("p", {
      children: description
    })]
  }));
};

var _excluded$6 = ["items"];
var Promos = function Promos(_ref) {
  var items = _ref.items,
    props = _objectWithoutProperties$1(_ref, _excluded$6);
  var domAttributes = pickDomAttributes(props);
  return jsx(Columns, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: items && items.map(function (promo) {
      var _promo$title;
      return jsx(Columns.Column, {
        className: "promo",
        children: jsx(Promo, _objectSpread2$1({}, promo))
      }, "".concat(promo === null || promo === void 0 ? void 0 : (_promo$title = promo.title) === null || _promo$title === void 0 ? void 0 : _promo$title.replace(' ', '')));
    })
  }));
};

var _excluded$5 = ["heading", "images", "children", "reverse", "firstColumnWidth"];
var TwoColumns = function TwoColumns(_ref) {
  var heading = _ref.heading,
    images = _ref.images,
    children = _ref.children,
    reverse = _ref.reverse,
    _ref$firstColumnWidth = _ref.firstColumnWidth,
    firstColumnWidth = _ref$firstColumnWidth === void 0 ? 'one-third' : _ref$firstColumnWidth,
    props = _objectWithoutProperties$1(_ref, _excluded$5);
  var domAttributes = pickDomAttributes(props);
  return jsxs(Columns, _objectSpread2$1(_objectSpread2$1({
    className: reverse && 'reverse-row'
  }, domAttributes), {}, {
    children: [jsx(Columns.Column, {
      desktop: {
        size: firstColumnWidth
      },
      children: jsxs(Content$1, {
        children: [jsx("h2", {
          children: heading
        }), images && images.map(function (image) {
          return jsx("img", {
            src: image.url,
            alt: image.alt
          }, image.url);
        })]
      })
    }), jsx(Columns.Column, {
      children: jsx(Content$1, {
        children: children
      })
    })]
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ExpenseContainer = /*#__PURE__*/_styled(Container, process.env.NODE_ENV === "production" ? {
  target: "ep8hid112"
} : {
  target: "ep8hid112",
  label: "ExpenseContainer"
})("background-color:", colors.wildSand, ";padding:1rem;", mediaQueries.forDesktopUp, "{padding:107px 156px 150px 157px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var ClearDiv = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ep8hid111"
} : {
  target: "ep8hid111",
  label: "ClearDiv"
})(process.env.NODE_ENV === "production" ? {
  name: "sffzb7",
  styles: "clear:both"
} : {
  name: "sffzb7",
  styles: "clear:both",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var H4$1 = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "ep8hid110"
} : {
  target: "ep8hid110",
  label: "H4"
})("color:", colors.stTropaz, ";&.title{font-size:1.688rem;letter-spacing:0;margin-bottom:1rem;font-weight:normal;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Content = /*#__PURE__*/_styled(Content$1, process.env.NODE_ENV === "production" ? {
  target: "ep8hid19"
} : {
  target: "ep8hid19",
  label: "Content"
})("font-size:1rem;letter-spacing:0;color:", colors.mirage, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4cGVuc2VTdXBwb3J0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxQ2dDIiwiZmlsZSI6IkV4cGVuc2VTdXBwb3J0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgRG9tQXR0cmlidXRlUHJvcHMgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11dGlsaXRpZXMnO1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgKiBhcyBjb2xvcnMgZnJvbSAnQGJnZWEtanMvY29sb3JzJztcbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBpbXBvcnQvbmFtZWRcbmltcG9ydCB7IG1lZGlhUXVlcmllcywgcGlja0RvbUF0dHJpYnV0ZXMgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11dGlsaXRpZXMnO1xuaW1wb3J0IHtcbiAgQmxvY2sgYXMgQkJsb2NrLFxuICBDb2x1bW5zLFxuICBDb250YWluZXIsXG4gIENvbnRlbnQgYXMgQkNvbnRlbnQsXG4gIEhlYWRpbmcsXG59IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LXVpJztcblxuY29uc3QgRXhwZW5zZUNvbnRhaW5lciA9IHN0eWxlZChDb250YWluZXIpYFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9ycy53aWxkU2FuZH07XG4gIHBhZGRpbmc6IDFyZW07XG5cbiAgJHttZWRpYVF1ZXJpZXMuZm9yRGVza3RvcFVwfSB7XG4gICAgcGFkZGluZzogMTA3cHggMTU2cHggMTUwcHggMTU3cHg7XG4gIH1cbmA7XG5cbmNvbnN0IENsZWFyRGl2ID0gc3R5bGVkLmRpdmBcbiAgY2xlYXI6IGJvdGg7XG5gO1xuXG5jb25zdCBINCA9IHN0eWxlZChIZWFkaW5nKWBcbiAgY29sb3I6ICR7Y29sb3JzLnN0VHJvcGF6fTtcbiAgJi50aXRsZSB7XG4gICAgZm9udC1zaXplOiAxLjY4OHJlbTtcbiAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIH1cbmA7XG5cbmNvbnN0IENvbnRlbnQgPSBzdHlsZWQoQkNvbnRlbnQpYFxuICBmb250LXNpemU6IDFyZW07XG4gIGxldHRlci1zcGFjaW5nOiAwO1xuICBjb2xvcjogJHtjb2xvcnMubWlyYWdlfTtcbmA7XG5cbmNvbnN0IEJsb2NrID0gc3R5bGVkKEJCbG9jaylgXG4gIGJvcmRlci10b3A6IDFweCBkYXNoZWQgJHtjb2xvcnMuZG92ZUdyYXl9O1xuICBwYWRkaW5nLXRvcDogMjBweDtcbmA7XG5cbmNvbnN0IExpbmsgPSBzdHlsZWQuYWBcbiAgZm9udC1zaXplOiAxcmVtO1xuICBsZXR0ZXItc3BhY2luZzogMDtcbiAgY29sb3I6ICR7Y29sb3JzLnN0VHJvcGF6fTtcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuXG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAke2NvbG9ycy5zdFRyb3Bhen07XG4gICAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIH1cbmA7XG5cbmNvbnN0IENvbnRlbnRMaW5rID0gc3R5bGVkLmFgXG4gIGZvbnQtc2l6ZTogMXJlbTtcbiAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gIGNvbG9yOiAke2NvbG9ycy5ibGFja307XG4gIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuXG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAke2NvbG9ycy5ibGFja307XG4gIH1cbmA7XG5cbmNvbnN0IFJldmVudWVIZWFkaW5nID0gc3R5bGVkKEhlYWRpbmcpYFxuICAmLnRpdGxlIHtcbiAgICBmb250LXNpemU6IDAuOTM4cmVtO1xuICAgIGNvbG9yOiAke2NvbG9ycy5ib3N0b25CbHVlfTtcbiAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gICAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbiAgfVxuYDtcblxuY29uc3QgVmlzYSA9IHN0eWxlZC5pYFxuICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiAwIDA7XG4gIGJhY2tncm91bmQtaW1hZ2U6IHVybChodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9hcHAvdGhlbWVzL2JpbGx5Z3JhaGFtL2ltZy9zZWN0aW9uL2RvbmF0aW9ucy9wYXltZW50c3ByaXRlLnBuZyk7XG4gIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogNTJweDtcbiAgaGVpZ2h0OiA0MXB4O1xuICBmbG9hdDogbGVmdDtcbiAgbWFyZ2luLXJpZ2h0OiAxZW07XG5gO1xuXG5jb25zdCBNYXN0ZXJDYXJkID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC01OHB4IDA7XG4gIGJhY2tncm91bmQtaW1hZ2U6IHVybChodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9hcHAvdGhlbWVzL2JpbGx5Z3JhaGFtL2ltZy9zZWN0aW9uL2RvbmF0aW9ucy9wYXltZW50c3ByaXRlLnBuZyk7XG4gIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogNTJweDtcbiAgaGVpZ2h0OiA0MXB4O1xuICBmbG9hdDogbGVmdDtcbiAgbWFyZ2luLXJpZ2h0OiAxZW07XG5gO1xuXG5jb25zdCBBbWV4ID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0xMTZweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuY29uc3QgRGlzY292ZXJ5ID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0xNzRweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuY29uc3QgUGF5cGFsID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0yMzJweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuZXhwb3J0IGludGVyZmFjZSBQcm9wcyBleHRlbmRzIERvbUF0dHJpYnV0ZVByb3BzIHt9XG5cbi8qKlxuICogIEJHRUEgRXhwZW5zZSBkYXRhIHRvIGJlIGxvY2F0ZWQgYXQgdGhlIGJvdHRvbSBvZiBhIHBhZ2UgYWJvdmUgdGhlIGZvb3RlclxuICpcbiAqIGBgYGpzXG4gKiBpbXBvcnQgeyBFeHBlbnNlU3VwcG9ydCB9IGZyb20gJ0BiZ2VhLWpzL2Rlc2lnbi1saWJyYXJ5JztcbiAqIGBgYFxuICovXG5leHBvcnQgY29uc3QgRXhwZW5zZVN1cHBvcnQgPSAoeyAuLi5wcm9wcyB9OiBQcm9wcykgPT4ge1xuICBjb25zdCBkb21BdHRyaWJ1dGVzID0gcGlja0RvbUF0dHJpYnV0ZXMocHJvcHMpO1xuICByZXR1cm4gKFxuICAgIDxFeHBlbnNlQ29udGFpbmVyIHsuLi5kb21BdHRyaWJ1dGVzfT5cbiAgICAgIDxDb2x1bW5zPlxuICAgICAgICA8Q29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgPEg0IHJlbmRlckFzPVwiaDRcIj5Qcml2YWN5IFBvbGljeTwvSDQ+XG4gICAgICAgICAgPENvbnRlbnQ+XG4gICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgQnkgcHJvdmlkaW5nIHlvdXIgcGVyc29uYWwgZGV0YWlscywgeW91IGFjY2VwdCB0aGF0IHdlIHdpbGwgdXNlXG4gICAgICAgICAgICAgIHlvdXIgcGVyc29uYWwgZGV0YWlscyB0byBjb21tdW5pY2F0ZSB3aXRoIHlvdSBhYm91dCBtaW5pc3RyeVxuICAgICAgICAgICAgICB1cGRhdGVzIGFuZCBvcHBvcnR1bml0aWVzIGZyb20gQmlsbHkgR3JhaGFtIEV2YW5nZWxpc3RpY1xuICAgICAgICAgICAgICBBc3NvY2lhdGlvbi57JyAnfVxuICAgICAgICAgICAgICA8Q29udGVudExpbmsgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL3ByaXZhY3ktcG9saWN5L1wiPlxuICAgICAgICAgICAgICAgIFZpZXcgb3VyIGZ1bGwgUHJpdmFjeSBQb2xpY3lcbiAgICAgICAgICAgICAgPC9Db250ZW50TGluaz5cbiAgICAgICAgICAgICAgLlxuICAgICAgICAgICAgPC9wPlxuICAgICAgICAgICAgPHA+XG4gICAgICAgICAgICAgIFRoaXMgZm9ybSBpcyBmb3IgVS5TLiByZXNpZGVudHMgb25seS4gQ2FuYWRpYW4gcmVzaWRlbnRzIG1heSBnaXZlXG4gICAgICAgICAgICAgIHRocm91Z2ggdGhleycgJ31cbiAgICAgICAgICAgICAgPENvbnRlbnRMaW5rIGhyZWY9XCJodHRwczovL3NlY3VyZS5iaWxseWdyYWhhbS5jYS9kb25hdGUvXCI+XG4gICAgICAgICAgICAgICAgQkdFQSBDYW5hZGEgd2Vic2l0ZVxuICAgICAgICAgICAgICA8L0NvbnRlbnRMaW5rPlxuICAgICAgICAgICAgICAuXG4gICAgICAgICAgICA8L3A+XG4gICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgQWxsIGdpZnRzIGRlc2lnbmF0ZWQgZm9yIGEgc3BlY2lmaWMgcHJvamVjdCB3aWxsIGJlIGFwcGxpZWQgdG8gdGhlXG4gICAgICAgICAgICAgIHByb2plY3Qgd2l0aCB1cCB0byAxMCUgdXNlZCBmb3IgYWRtaW5pc3RyYXRpdmUgYW5kIGZ1bmQtcmFpc2luZ1xuICAgICAgICAgICAgICBleHBlbnNlcy4gVGhpcyBpcyBhIHNlY3VyZSBmb3JtIHVzaW5nIGluZHVzdHJ5IHN0YW5kYXJkIFNTTFxuICAgICAgICAgICAgICBlbmNyeXB0aW9uIHRlY2hub2xvZ3kuXG4gICAgICAgICAgICA8L3A+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICAgIDxDb250ZW50PlxuICAgICAgICAgICAgPENvbHVtbnM+XG4gICAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbj5cbiAgICAgICAgICAgICAgICA8TGlua1xuICAgICAgICAgICAgICAgICAgdGFyZ2V0PVwiX2JsYW5rXCJcbiAgICAgICAgICAgICAgICAgIGhyZWY9XCJodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9zb2xpY2l0YXRpb24tZGlzY2xvc3VyZS1zdGF0ZW1lbnQvXCJcbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICBTb2xpY2l0YXRpb24gRGlzY2xvc3VyZSBTdGF0ZW1lbnRcbiAgICAgICAgICAgICAgICA8L0xpbms+XG4gICAgICAgICAgICAgIDwvQ29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbj5cbiAgICAgICAgICAgICAgICA8TGluayBocmVmPVwiaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvcHJpdmFjeS1wb2xpY3lcIj5cbiAgICAgICAgICAgICAgICAgIFByaXZhY3kgUG9saWN5XG4gICAgICAgICAgICAgICAgPC9MaW5rPlxuICAgICAgICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgICAgICAgPC9Db2x1bW5zPlxuICAgICAgICAgIDwvQ29udGVudD5cbiAgICAgICAgICA8QmxvY2s+XG4gICAgICAgICAgICA8VmlzYSAvPlxuICAgICAgICAgICAgPE1hc3RlckNhcmQgLz5cbiAgICAgICAgICAgIDxBbWV4IC8+XG4gICAgICAgICAgICA8RGlzY292ZXJ5IC8+XG4gICAgICAgICAgICA8UGF5cGFsIC8+XG4gICAgICAgICAgICA8Q2xlYXJEaXYgLz5cbiAgICAgICAgICA8L0Jsb2NrPlxuICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgICA8Q29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgPEg0IHJlbmRlckFzPVwiaDRcIj5GaW5hbmNpYWwgQWNjb3VudGFiaWxpdHk8L0g0PlxuICAgICAgICAgIDxDb250ZW50PlxuICAgICAgICAgICAgPFJldmVudWVIZWFkaW5nIHJlbmRlckFzPVwiaDRcIj5cbiAgICAgICAgICAgICAgMjAyNCBCR0VBIE9wZXJhdGluZyBTdXBwb3J0IGFuZCBSZXZlbnVlXG4gICAgICAgICAgICA8L1JldmVudWVIZWFkaW5nPlxuICAgICAgICAgICAgPGFcbiAgICAgICAgICAgICAgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL2Fib3V0L2ZpbmFuY2lhbC1pbmZvL1wiXG4gICAgICAgICAgICAgIHRpdGxlPVwiIEJpbGx5IEdyYWhhbSBGaW5hbmNpYWwgSW5mb1wiXG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIDxpbWdcbiAgICAgICAgICAgICAgICBzcmM9XCJodHRwczovL3MzLnRoZWFyay5jbG91ZC9zdGF0aWMtYmlsbHlncmFoYW0tb3JnL3NpdGVzL2JpbGx5Z3JhaGFtLm9yZy91cGxvYWRzL3Byb2QvMjAyNS8wNC8yMDI0X29wZXJhdGluZ19zdXBwb3J0X3JldmVudWUucG5nXCJcbiAgICAgICAgICAgICAgICBhbHQ9XCJDb250cmlidXRpb25zLCA4OC42JTsgQmlsbHkgR3JhaGFtIFRyYWluaW5nIENlbnRlciwgNC41JTsgRGVjaXNpb24gTWFnYXppbmUgJiBvdGhlciBldmFuZ2VsaXN0aWMgbWF0ZXJpYWxzLCAxLjIlOyBPdGhlciBpbmNvbWUsIDUuNyUuXCJcbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvYT5cbiAgICAgICAgICA8L0NvbnRlbnQ+XG4gICAgICAgICAgPENvbnRlbnQ+XG4gICAgICAgICAgICA8UmV2ZW51ZUhlYWRpbmcgcmVuZGVyQXM9XCJoNFwiPlxuICAgICAgICAgICAgICAyMDI0IEJHRUEgT3BlcmF0aW5nIEV4cGVuc2VzXG4gICAgICAgICAgICA8L1JldmVudWVIZWFkaW5nPlxuICAgICAgICAgICAgPGFcbiAgICAgICAgICAgICAgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL2Fib3V0L2ZpbmFuY2lhbC1pbmZvL1wiXG4gICAgICAgICAgICAgIHRpdGxlPVwiQmlsbHkgR3JhaGFtIEZpbmFuY2lhbCBJbmZvXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgPGltZ1xuICAgICAgICAgICAgICAgIHNyYz1cImh0dHBzOi8vczMudGhlYXJrLmNsb3VkL3N0YXRpYy1iaWxseWdyYWhhbS1vcmcvc2l0ZXMvYmlsbHlncmFoYW0ub3JnL3VwbG9hZHMvcHJvZC8yMDI1LzA0LzIwMjRfb3BlcmF0aW5nX2V4cGVuc2VzLnBuZ1wiXG4gICAgICAgICAgICAgICAgYWx0PVwiTWluaXN0cnkgZXhwZW5zZXMsIDg3LjIlOyBGdW5kcmFpc2luZywgNC41JTsgR2VuZXJhbCAmIEFkbWluaXN0cmF0aXZlLCA4LjMlLlwiXG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8L2E+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgPC9Db2x1bW5zPlxuICAgIDwvRXhwZW5zZUNvbnRhaW5lcj5cbiAgKTtcbn07XG4iXX0= */"));
var Block = /*#__PURE__*/_styled(Block$1, process.env.NODE_ENV === "production" ? {
  target: "ep8hid18"
} : {
  target: "ep8hid18",
  label: "Block"
})("border-top:1px dashed ", colors.doveGray, ";padding-top:20px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Link$1 = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "ep8hid17"
} : {
  target: "ep8hid17",
  label: "Link"
})("font-size:1rem;letter-spacing:0;color:", colors.stTropaz, ";text-decoration:none;&:hover{color:", colors.stTropaz, ";text-decoration:underline;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4cGVuc2VTdXBwb3J0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnRHFCIiwiZmlsZSI6IkV4cGVuc2VTdXBwb3J0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgRG9tQXR0cmlidXRlUHJvcHMgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11dGlsaXRpZXMnO1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgKiBhcyBjb2xvcnMgZnJvbSAnQGJnZWEtanMvY29sb3JzJztcbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBpbXBvcnQvbmFtZWRcbmltcG9ydCB7IG1lZGlhUXVlcmllcywgcGlja0RvbUF0dHJpYnV0ZXMgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11dGlsaXRpZXMnO1xuaW1wb3J0IHtcbiAgQmxvY2sgYXMgQkJsb2NrLFxuICBDb2x1bW5zLFxuICBDb250YWluZXIsXG4gIENvbnRlbnQgYXMgQkNvbnRlbnQsXG4gIEhlYWRpbmcsXG59IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LXVpJztcblxuY29uc3QgRXhwZW5zZUNvbnRhaW5lciA9IHN0eWxlZChDb250YWluZXIpYFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9ycy53aWxkU2FuZH07XG4gIHBhZGRpbmc6IDFyZW07XG5cbiAgJHttZWRpYVF1ZXJpZXMuZm9yRGVza3RvcFVwfSB7XG4gICAgcGFkZGluZzogMTA3cHggMTU2cHggMTUwcHggMTU3cHg7XG4gIH1cbmA7XG5cbmNvbnN0IENsZWFyRGl2ID0gc3R5bGVkLmRpdmBcbiAgY2xlYXI6IGJvdGg7XG5gO1xuXG5jb25zdCBINCA9IHN0eWxlZChIZWFkaW5nKWBcbiAgY29sb3I6ICR7Y29sb3JzLnN0VHJvcGF6fTtcbiAgJi50aXRsZSB7XG4gICAgZm9udC1zaXplOiAxLjY4OHJlbTtcbiAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIH1cbmA7XG5cbmNvbnN0IENvbnRlbnQgPSBzdHlsZWQoQkNvbnRlbnQpYFxuICBmb250LXNpemU6IDFyZW07XG4gIGxldHRlci1zcGFjaW5nOiAwO1xuICBjb2xvcjogJHtjb2xvcnMubWlyYWdlfTtcbmA7XG5cbmNvbnN0IEJsb2NrID0gc3R5bGVkKEJCbG9jaylgXG4gIGJvcmRlci10b3A6IDFweCBkYXNoZWQgJHtjb2xvcnMuZG92ZUdyYXl9O1xuICBwYWRkaW5nLXRvcDogMjBweDtcbmA7XG5cbmNvbnN0IExpbmsgPSBzdHlsZWQuYWBcbiAgZm9udC1zaXplOiAxcmVtO1xuICBsZXR0ZXItc3BhY2luZzogMDtcbiAgY29sb3I6ICR7Y29sb3JzLnN0VHJvcGF6fTtcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuXG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAke2NvbG9ycy5zdFRyb3Bhen07XG4gICAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIH1cbmA7XG5cbmNvbnN0IENvbnRlbnRMaW5rID0gc3R5bGVkLmFgXG4gIGZvbnQtc2l6ZTogMXJlbTtcbiAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gIGNvbG9yOiAke2NvbG9ycy5ibGFja307XG4gIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuXG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAke2NvbG9ycy5ibGFja307XG4gIH1cbmA7XG5cbmNvbnN0IFJldmVudWVIZWFkaW5nID0gc3R5bGVkKEhlYWRpbmcpYFxuICAmLnRpdGxlIHtcbiAgICBmb250LXNpemU6IDAuOTM4cmVtO1xuICAgIGNvbG9yOiAke2NvbG9ycy5ib3N0b25CbHVlfTtcbiAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gICAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbiAgfVxuYDtcblxuY29uc3QgVmlzYSA9IHN0eWxlZC5pYFxuICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiAwIDA7XG4gIGJhY2tncm91bmQtaW1hZ2U6IHVybChodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9hcHAvdGhlbWVzL2JpbGx5Z3JhaGFtL2ltZy9zZWN0aW9uL2RvbmF0aW9ucy9wYXltZW50c3ByaXRlLnBuZyk7XG4gIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogNTJweDtcbiAgaGVpZ2h0OiA0MXB4O1xuICBmbG9hdDogbGVmdDtcbiAgbWFyZ2luLXJpZ2h0OiAxZW07XG5gO1xuXG5jb25zdCBNYXN0ZXJDYXJkID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC01OHB4IDA7XG4gIGJhY2tncm91bmQtaW1hZ2U6IHVybChodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9hcHAvdGhlbWVzL2JpbGx5Z3JhaGFtL2ltZy9zZWN0aW9uL2RvbmF0aW9ucy9wYXltZW50c3ByaXRlLnBuZyk7XG4gIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogNTJweDtcbiAgaGVpZ2h0OiA0MXB4O1xuICBmbG9hdDogbGVmdDtcbiAgbWFyZ2luLXJpZ2h0OiAxZW07XG5gO1xuXG5jb25zdCBBbWV4ID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0xMTZweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuY29uc3QgRGlzY292ZXJ5ID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0xNzRweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuY29uc3QgUGF5cGFsID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0yMzJweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuZXhwb3J0IGludGVyZmFjZSBQcm9wcyBleHRlbmRzIERvbUF0dHJpYnV0ZVByb3BzIHt9XG5cbi8qKlxuICogIEJHRUEgRXhwZW5zZSBkYXRhIHRvIGJlIGxvY2F0ZWQgYXQgdGhlIGJvdHRvbSBvZiBhIHBhZ2UgYWJvdmUgdGhlIGZvb3RlclxuICpcbiAqIGBgYGpzXG4gKiBpbXBvcnQgeyBFeHBlbnNlU3VwcG9ydCB9IGZyb20gJ0BiZ2VhLWpzL2Rlc2lnbi1saWJyYXJ5JztcbiAqIGBgYFxuICovXG5leHBvcnQgY29uc3QgRXhwZW5zZVN1cHBvcnQgPSAoeyAuLi5wcm9wcyB9OiBQcm9wcykgPT4ge1xuICBjb25zdCBkb21BdHRyaWJ1dGVzID0gcGlja0RvbUF0dHJpYnV0ZXMocHJvcHMpO1xuICByZXR1cm4gKFxuICAgIDxFeHBlbnNlQ29udGFpbmVyIHsuLi5kb21BdHRyaWJ1dGVzfT5cbiAgICAgIDxDb2x1bW5zPlxuICAgICAgICA8Q29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgPEg0IHJlbmRlckFzPVwiaDRcIj5Qcml2YWN5IFBvbGljeTwvSDQ+XG4gICAgICAgICAgPENvbnRlbnQ+XG4gICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgQnkgcHJvdmlkaW5nIHlvdXIgcGVyc29uYWwgZGV0YWlscywgeW91IGFjY2VwdCB0aGF0IHdlIHdpbGwgdXNlXG4gICAgICAgICAgICAgIHlvdXIgcGVyc29uYWwgZGV0YWlscyB0byBjb21tdW5pY2F0ZSB3aXRoIHlvdSBhYm91dCBtaW5pc3RyeVxuICAgICAgICAgICAgICB1cGRhdGVzIGFuZCBvcHBvcnR1bml0aWVzIGZyb20gQmlsbHkgR3JhaGFtIEV2YW5nZWxpc3RpY1xuICAgICAgICAgICAgICBBc3NvY2lhdGlvbi57JyAnfVxuICAgICAgICAgICAgICA8Q29udGVudExpbmsgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL3ByaXZhY3ktcG9saWN5L1wiPlxuICAgICAgICAgICAgICAgIFZpZXcgb3VyIGZ1bGwgUHJpdmFjeSBQb2xpY3lcbiAgICAgICAgICAgICAgPC9Db250ZW50TGluaz5cbiAgICAgICAgICAgICAgLlxuICAgICAgICAgICAgPC9wPlxuICAgICAgICAgICAgPHA+XG4gICAgICAgICAgICAgIFRoaXMgZm9ybSBpcyBmb3IgVS5TLiByZXNpZGVudHMgb25seS4gQ2FuYWRpYW4gcmVzaWRlbnRzIG1heSBnaXZlXG4gICAgICAgICAgICAgIHRocm91Z2ggdGhleycgJ31cbiAgICAgICAgICAgICAgPENvbnRlbnRMaW5rIGhyZWY9XCJodHRwczovL3NlY3VyZS5iaWxseWdyYWhhbS5jYS9kb25hdGUvXCI+XG4gICAgICAgICAgICAgICAgQkdFQSBDYW5hZGEgd2Vic2l0ZVxuICAgICAgICAgICAgICA8L0NvbnRlbnRMaW5rPlxuICAgICAgICAgICAgICAuXG4gICAgICAgICAgICA8L3A+XG4gICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgQWxsIGdpZnRzIGRlc2lnbmF0ZWQgZm9yIGEgc3BlY2lmaWMgcHJvamVjdCB3aWxsIGJlIGFwcGxpZWQgdG8gdGhlXG4gICAgICAgICAgICAgIHByb2plY3Qgd2l0aCB1cCB0byAxMCUgdXNlZCBmb3IgYWRtaW5pc3RyYXRpdmUgYW5kIGZ1bmQtcmFpc2luZ1xuICAgICAgICAgICAgICBleHBlbnNlcy4gVGhpcyBpcyBhIHNlY3VyZSBmb3JtIHVzaW5nIGluZHVzdHJ5IHN0YW5kYXJkIFNTTFxuICAgICAgICAgICAgICBlbmNyeXB0aW9uIHRlY2hub2xvZ3kuXG4gICAgICAgICAgICA8L3A+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICAgIDxDb250ZW50PlxuICAgICAgICAgICAgPENvbHVtbnM+XG4gICAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbj5cbiAgICAgICAgICAgICAgICA8TGlua1xuICAgICAgICAgICAgICAgICAgdGFyZ2V0PVwiX2JsYW5rXCJcbiAgICAgICAgICAgICAgICAgIGhyZWY9XCJodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9zb2xpY2l0YXRpb24tZGlzY2xvc3VyZS1zdGF0ZW1lbnQvXCJcbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICBTb2xpY2l0YXRpb24gRGlzY2xvc3VyZSBTdGF0ZW1lbnRcbiAgICAgICAgICAgICAgICA8L0xpbms+XG4gICAgICAgICAgICAgIDwvQ29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbj5cbiAgICAgICAgICAgICAgICA8TGluayBocmVmPVwiaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvcHJpdmFjeS1wb2xpY3lcIj5cbiAgICAgICAgICAgICAgICAgIFByaXZhY3kgUG9saWN5XG4gICAgICAgICAgICAgICAgPC9MaW5rPlxuICAgICAgICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgICAgICAgPC9Db2x1bW5zPlxuICAgICAgICAgIDwvQ29udGVudD5cbiAgICAgICAgICA8QmxvY2s+XG4gICAgICAgICAgICA8VmlzYSAvPlxuICAgICAgICAgICAgPE1hc3RlckNhcmQgLz5cbiAgICAgICAgICAgIDxBbWV4IC8+XG4gICAgICAgICAgICA8RGlzY292ZXJ5IC8+XG4gICAgICAgICAgICA8UGF5cGFsIC8+XG4gICAgICAgICAgICA8Q2xlYXJEaXYgLz5cbiAgICAgICAgICA8L0Jsb2NrPlxuICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgICA8Q29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgPEg0IHJlbmRlckFzPVwiaDRcIj5GaW5hbmNpYWwgQWNjb3VudGFiaWxpdHk8L0g0PlxuICAgICAgICAgIDxDb250ZW50PlxuICAgICAgICAgICAgPFJldmVudWVIZWFkaW5nIHJlbmRlckFzPVwiaDRcIj5cbiAgICAgICAgICAgICAgMjAyNCBCR0VBIE9wZXJhdGluZyBTdXBwb3J0IGFuZCBSZXZlbnVlXG4gICAgICAgICAgICA8L1JldmVudWVIZWFkaW5nPlxuICAgICAgICAgICAgPGFcbiAgICAgICAgICAgICAgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL2Fib3V0L2ZpbmFuY2lhbC1pbmZvL1wiXG4gICAgICAgICAgICAgIHRpdGxlPVwiIEJpbGx5IEdyYWhhbSBGaW5hbmNpYWwgSW5mb1wiXG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIDxpbWdcbiAgICAgICAgICAgICAgICBzcmM9XCJodHRwczovL3MzLnRoZWFyay5jbG91ZC9zdGF0aWMtYmlsbHlncmFoYW0tb3JnL3NpdGVzL2JpbGx5Z3JhaGFtLm9yZy91cGxvYWRzL3Byb2QvMjAyNS8wNC8yMDI0X29wZXJhdGluZ19zdXBwb3J0X3JldmVudWUucG5nXCJcbiAgICAgICAgICAgICAgICBhbHQ9XCJDb250cmlidXRpb25zLCA4OC42JTsgQmlsbHkgR3JhaGFtIFRyYWluaW5nIENlbnRlciwgNC41JTsgRGVjaXNpb24gTWFnYXppbmUgJiBvdGhlciBldmFuZ2VsaXN0aWMgbWF0ZXJpYWxzLCAxLjIlOyBPdGhlciBpbmNvbWUsIDUuNyUuXCJcbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvYT5cbiAgICAgICAgICA8L0NvbnRlbnQ+XG4gICAgICAgICAgPENvbnRlbnQ+XG4gICAgICAgICAgICA8UmV2ZW51ZUhlYWRpbmcgcmVuZGVyQXM9XCJoNFwiPlxuICAgICAgICAgICAgICAyMDI0IEJHRUEgT3BlcmF0aW5nIEV4cGVuc2VzXG4gICAgICAgICAgICA8L1JldmVudWVIZWFkaW5nPlxuICAgICAgICAgICAgPGFcbiAgICAgICAgICAgICAgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL2Fib3V0L2ZpbmFuY2lhbC1pbmZvL1wiXG4gICAgICAgICAgICAgIHRpdGxlPVwiQmlsbHkgR3JhaGFtIEZpbmFuY2lhbCBJbmZvXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgPGltZ1xuICAgICAgICAgICAgICAgIHNyYz1cImh0dHBzOi8vczMudGhlYXJrLmNsb3VkL3N0YXRpYy1iaWxseWdyYWhhbS1vcmcvc2l0ZXMvYmlsbHlncmFoYW0ub3JnL3VwbG9hZHMvcHJvZC8yMDI1LzA0LzIwMjRfb3BlcmF0aW5nX2V4cGVuc2VzLnBuZ1wiXG4gICAgICAgICAgICAgICAgYWx0PVwiTWluaXN0cnkgZXhwZW5zZXMsIDg3LjIlOyBGdW5kcmFpc2luZywgNC41JTsgR2VuZXJhbCAmIEFkbWluaXN0cmF0aXZlLCA4LjMlLlwiXG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8L2E+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgPC9Db2x1bW5zPlxuICAgIDwvRXhwZW5zZUNvbnRhaW5lcj5cbiAgKTtcbn07XG4iXX0= */"));
var ContentLink = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "ep8hid16"
} : {
  target: "ep8hid16",
  label: "ContentLink"
})("font-size:1rem;letter-spacing:0;color:", colors.black, ";text-decoration:underline;&:hover{color:", colors.black, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var RevenueHeading = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "ep8hid15"
} : {
  target: "ep8hid15",
  label: "RevenueHeading"
})("&.title{font-size:0.938rem;color:", colors.bostonBlue, ";letter-spacing:0;margin-bottom:1rem;font-weight:normal;text-transform:uppercase;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Visa = /*#__PURE__*/_styled("i", process.env.NODE_ENV === "production" ? {
  target: "ep8hid14"
} : {
  target: "ep8hid14",
  label: "Visa"
})(process.env.NODE_ENV === "production" ? {
  name: "fj4s3q",
  styles: "background-position:0 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em"
} : {
  name: "fj4s3q",
  styles: "background-position:0 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var MasterCard = /*#__PURE__*/_styled("i", process.env.NODE_ENV === "production" ? {
  target: "ep8hid13"
} : {
  target: "ep8hid13",
  label: "MasterCard"
})(process.env.NODE_ENV === "production" ? {
  name: "1osxg66",
  styles: "background-position:-58px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em"
} : {
  name: "1osxg66",
  styles: "background-position:-58px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var Amex = /*#__PURE__*/_styled("i", process.env.NODE_ENV === "production" ? {
  target: "ep8hid12"
} : {
  target: "ep8hid12",
  label: "Amex"
})(process.env.NODE_ENV === "production" ? {
  name: "1jazxv8",
  styles: "background-position:-116px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em"
} : {
  name: "1jazxv8",
  styles: "background-position:-116px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var Discovery = /*#__PURE__*/_styled("i", process.env.NODE_ENV === "production" ? {
  target: "ep8hid11"
} : {
  target: "ep8hid11",
  label: "Discovery"
})(process.env.NODE_ENV === "production" ? {
  name: "1s6bj9r",
  styles: "background-position:-174px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em"
} : {
  name: "1s6bj9r",
  styles: "background-position:-174px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var Paypal = /*#__PURE__*/_styled("i", process.env.NODE_ENV === "production" ? {
  target: "ep8hid10"
} : {
  target: "ep8hid10",
  label: "Paypal"
})(process.env.NODE_ENV === "production" ? {
  name: "vtgk18",
  styles: "background-position:-232px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em"
} : {
  name: "vtgk18",
  styles: "background-position:-232px 0;background-image:url(https://billygraham.org/app/themes/billygraham/img/section/donations/paymentsprite.png);background-repeat:no-repeat;display:block;width:52px;height:41px;float:left;margin-right:1em",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4cGVuc2VTdXBwb3J0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE4SHVCIiwiZmlsZSI6IkV4cGVuc2VTdXBwb3J0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgRG9tQXR0cmlidXRlUHJvcHMgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11dGlsaXRpZXMnO1xuXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgKiBhcyBjb2xvcnMgZnJvbSAnQGJnZWEtanMvY29sb3JzJztcbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBpbXBvcnQvbmFtZWRcbmltcG9ydCB7IG1lZGlhUXVlcmllcywgcGlja0RvbUF0dHJpYnV0ZXMgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11dGlsaXRpZXMnO1xuaW1wb3J0IHtcbiAgQmxvY2sgYXMgQkJsb2NrLFxuICBDb2x1bW5zLFxuICBDb250YWluZXIsXG4gIENvbnRlbnQgYXMgQkNvbnRlbnQsXG4gIEhlYWRpbmcsXG59IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LXVpJztcblxuY29uc3QgRXhwZW5zZUNvbnRhaW5lciA9IHN0eWxlZChDb250YWluZXIpYFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9ycy53aWxkU2FuZH07XG4gIHBhZGRpbmc6IDFyZW07XG5cbiAgJHttZWRpYVF1ZXJpZXMuZm9yRGVza3RvcFVwfSB7XG4gICAgcGFkZGluZzogMTA3cHggMTU2cHggMTUwcHggMTU3cHg7XG4gIH1cbmA7XG5cbmNvbnN0IENsZWFyRGl2ID0gc3R5bGVkLmRpdmBcbiAgY2xlYXI6IGJvdGg7XG5gO1xuXG5jb25zdCBINCA9IHN0eWxlZChIZWFkaW5nKWBcbiAgY29sb3I6ICR7Y29sb3JzLnN0VHJvcGF6fTtcbiAgJi50aXRsZSB7XG4gICAgZm9udC1zaXplOiAxLjY4OHJlbTtcbiAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gIH1cbmA7XG5cbmNvbnN0IENvbnRlbnQgPSBzdHlsZWQoQkNvbnRlbnQpYFxuICBmb250LXNpemU6IDFyZW07XG4gIGxldHRlci1zcGFjaW5nOiAwO1xuICBjb2xvcjogJHtjb2xvcnMubWlyYWdlfTtcbmA7XG5cbmNvbnN0IEJsb2NrID0gc3R5bGVkKEJCbG9jaylgXG4gIGJvcmRlci10b3A6IDFweCBkYXNoZWQgJHtjb2xvcnMuZG92ZUdyYXl9O1xuICBwYWRkaW5nLXRvcDogMjBweDtcbmA7XG5cbmNvbnN0IExpbmsgPSBzdHlsZWQuYWBcbiAgZm9udC1zaXplOiAxcmVtO1xuICBsZXR0ZXItc3BhY2luZzogMDtcbiAgY29sb3I6ICR7Y29sb3JzLnN0VHJvcGF6fTtcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuXG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAke2NvbG9ycy5zdFRyb3Bhen07XG4gICAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIH1cbmA7XG5cbmNvbnN0IENvbnRlbnRMaW5rID0gc3R5bGVkLmFgXG4gIGZvbnQtc2l6ZTogMXJlbTtcbiAgbGV0dGVyLXNwYWNpbmc6IDA7XG4gIGNvbG9yOiAke2NvbG9ycy5ibGFja307XG4gIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuXG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAke2NvbG9ycy5ibGFja307XG4gIH1cbmA7XG5cbmNvbnN0IFJldmVudWVIZWFkaW5nID0gc3R5bGVkKEhlYWRpbmcpYFxuICAmLnRpdGxlIHtcbiAgICBmb250LXNpemU6IDAuOTM4cmVtO1xuICAgIGNvbG9yOiAke2NvbG9ycy5ib3N0b25CbHVlfTtcbiAgICBsZXR0ZXItc3BhY2luZzogMDtcbiAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICAgIGZvbnQtd2VpZ2h0OiBub3JtYWw7XG4gICAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbiAgfVxuYDtcblxuY29uc3QgVmlzYSA9IHN0eWxlZC5pYFxuICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiAwIDA7XG4gIGJhY2tncm91bmQtaW1hZ2U6IHVybChodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9hcHAvdGhlbWVzL2JpbGx5Z3JhaGFtL2ltZy9zZWN0aW9uL2RvbmF0aW9ucy9wYXltZW50c3ByaXRlLnBuZyk7XG4gIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogNTJweDtcbiAgaGVpZ2h0OiA0MXB4O1xuICBmbG9hdDogbGVmdDtcbiAgbWFyZ2luLXJpZ2h0OiAxZW07XG5gO1xuXG5jb25zdCBNYXN0ZXJDYXJkID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC01OHB4IDA7XG4gIGJhY2tncm91bmQtaW1hZ2U6IHVybChodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9hcHAvdGhlbWVzL2JpbGx5Z3JhaGFtL2ltZy9zZWN0aW9uL2RvbmF0aW9ucy9wYXltZW50c3ByaXRlLnBuZyk7XG4gIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICB3aWR0aDogNTJweDtcbiAgaGVpZ2h0OiA0MXB4O1xuICBmbG9hdDogbGVmdDtcbiAgbWFyZ2luLXJpZ2h0OiAxZW07XG5gO1xuXG5jb25zdCBBbWV4ID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0xMTZweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuY29uc3QgRGlzY292ZXJ5ID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0xNzRweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuY29uc3QgUGF5cGFsID0gc3R5bGVkLmlgXG4gIGJhY2tncm91bmQtcG9zaXRpb246IC0yMzJweCAwO1xuICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvYXBwL3RoZW1lcy9iaWxseWdyYWhhbS9pbWcvc2VjdGlvbi9kb25hdGlvbnMvcGF5bWVudHNwcml0ZS5wbmcpO1xuICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDUycHg7XG4gIGhlaWdodDogNDFweDtcbiAgZmxvYXQ6IGxlZnQ7XG4gIG1hcmdpbi1yaWdodDogMWVtO1xuYDtcblxuZXhwb3J0IGludGVyZmFjZSBQcm9wcyBleHRlbmRzIERvbUF0dHJpYnV0ZVByb3BzIHt9XG5cbi8qKlxuICogIEJHRUEgRXhwZW5zZSBkYXRhIHRvIGJlIGxvY2F0ZWQgYXQgdGhlIGJvdHRvbSBvZiBhIHBhZ2UgYWJvdmUgdGhlIGZvb3RlclxuICpcbiAqIGBgYGpzXG4gKiBpbXBvcnQgeyBFeHBlbnNlU3VwcG9ydCB9IGZyb20gJ0BiZ2VhLWpzL2Rlc2lnbi1saWJyYXJ5JztcbiAqIGBgYFxuICovXG5leHBvcnQgY29uc3QgRXhwZW5zZVN1cHBvcnQgPSAoeyAuLi5wcm9wcyB9OiBQcm9wcykgPT4ge1xuICBjb25zdCBkb21BdHRyaWJ1dGVzID0gcGlja0RvbUF0dHJpYnV0ZXMocHJvcHMpO1xuICByZXR1cm4gKFxuICAgIDxFeHBlbnNlQ29udGFpbmVyIHsuLi5kb21BdHRyaWJ1dGVzfT5cbiAgICAgIDxDb2x1bW5zPlxuICAgICAgICA8Q29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgPEg0IHJlbmRlckFzPVwiaDRcIj5Qcml2YWN5IFBvbGljeTwvSDQ+XG4gICAgICAgICAgPENvbnRlbnQ+XG4gICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgQnkgcHJvdmlkaW5nIHlvdXIgcGVyc29uYWwgZGV0YWlscywgeW91IGFjY2VwdCB0aGF0IHdlIHdpbGwgdXNlXG4gICAgICAgICAgICAgIHlvdXIgcGVyc29uYWwgZGV0YWlscyB0byBjb21tdW5pY2F0ZSB3aXRoIHlvdSBhYm91dCBtaW5pc3RyeVxuICAgICAgICAgICAgICB1cGRhdGVzIGFuZCBvcHBvcnR1bml0aWVzIGZyb20gQmlsbHkgR3JhaGFtIEV2YW5nZWxpc3RpY1xuICAgICAgICAgICAgICBBc3NvY2lhdGlvbi57JyAnfVxuICAgICAgICAgICAgICA8Q29udGVudExpbmsgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL3ByaXZhY3ktcG9saWN5L1wiPlxuICAgICAgICAgICAgICAgIFZpZXcgb3VyIGZ1bGwgUHJpdmFjeSBQb2xpY3lcbiAgICAgICAgICAgICAgPC9Db250ZW50TGluaz5cbiAgICAgICAgICAgICAgLlxuICAgICAgICAgICAgPC9wPlxuICAgICAgICAgICAgPHA+XG4gICAgICAgICAgICAgIFRoaXMgZm9ybSBpcyBmb3IgVS5TLiByZXNpZGVudHMgb25seS4gQ2FuYWRpYW4gcmVzaWRlbnRzIG1heSBnaXZlXG4gICAgICAgICAgICAgIHRocm91Z2ggdGhleycgJ31cbiAgICAgICAgICAgICAgPENvbnRlbnRMaW5rIGhyZWY9XCJodHRwczovL3NlY3VyZS5iaWxseWdyYWhhbS5jYS9kb25hdGUvXCI+XG4gICAgICAgICAgICAgICAgQkdFQSBDYW5hZGEgd2Vic2l0ZVxuICAgICAgICAgICAgICA8L0NvbnRlbnRMaW5rPlxuICAgICAgICAgICAgICAuXG4gICAgICAgICAgICA8L3A+XG4gICAgICAgICAgICA8cD5cbiAgICAgICAgICAgICAgQWxsIGdpZnRzIGRlc2lnbmF0ZWQgZm9yIGEgc3BlY2lmaWMgcHJvamVjdCB3aWxsIGJlIGFwcGxpZWQgdG8gdGhlXG4gICAgICAgICAgICAgIHByb2plY3Qgd2l0aCB1cCB0byAxMCUgdXNlZCBmb3IgYWRtaW5pc3RyYXRpdmUgYW5kIGZ1bmQtcmFpc2luZ1xuICAgICAgICAgICAgICBleHBlbnNlcy4gVGhpcyBpcyBhIHNlY3VyZSBmb3JtIHVzaW5nIGluZHVzdHJ5IHN0YW5kYXJkIFNTTFxuICAgICAgICAgICAgICBlbmNyeXB0aW9uIHRlY2hub2xvZ3kuXG4gICAgICAgICAgICA8L3A+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICAgIDxDb250ZW50PlxuICAgICAgICAgICAgPENvbHVtbnM+XG4gICAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbj5cbiAgICAgICAgICAgICAgICA8TGlua1xuICAgICAgICAgICAgICAgICAgdGFyZ2V0PVwiX2JsYW5rXCJcbiAgICAgICAgICAgICAgICAgIGhyZWY9XCJodHRwczovL2JpbGx5Z3JhaGFtLm9yZy9zb2xpY2l0YXRpb24tZGlzY2xvc3VyZS1zdGF0ZW1lbnQvXCJcbiAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICBTb2xpY2l0YXRpb24gRGlzY2xvc3VyZSBTdGF0ZW1lbnRcbiAgICAgICAgICAgICAgICA8L0xpbms+XG4gICAgICAgICAgICAgIDwvQ29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgICAgIDxDb2x1bW5zLkNvbHVtbj5cbiAgICAgICAgICAgICAgICA8TGluayBocmVmPVwiaHR0cHM6Ly9iaWxseWdyYWhhbS5vcmcvcHJpdmFjeS1wb2xpY3lcIj5cbiAgICAgICAgICAgICAgICAgIFByaXZhY3kgUG9saWN5XG4gICAgICAgICAgICAgICAgPC9MaW5rPlxuICAgICAgICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgICAgICAgPC9Db2x1bW5zPlxuICAgICAgICAgIDwvQ29udGVudD5cbiAgICAgICAgICA8QmxvY2s+XG4gICAgICAgICAgICA8VmlzYSAvPlxuICAgICAgICAgICAgPE1hc3RlckNhcmQgLz5cbiAgICAgICAgICAgIDxBbWV4IC8+XG4gICAgICAgICAgICA8RGlzY292ZXJ5IC8+XG4gICAgICAgICAgICA8UGF5cGFsIC8+XG4gICAgICAgICAgICA8Q2xlYXJEaXYgLz5cbiAgICAgICAgICA8L0Jsb2NrPlxuICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgICA8Q29sdW1ucy5Db2x1bW4+XG4gICAgICAgICAgPEg0IHJlbmRlckFzPVwiaDRcIj5GaW5hbmNpYWwgQWNjb3VudGFiaWxpdHk8L0g0PlxuICAgICAgICAgIDxDb250ZW50PlxuICAgICAgICAgICAgPFJldmVudWVIZWFkaW5nIHJlbmRlckFzPVwiaDRcIj5cbiAgICAgICAgICAgICAgMjAyNCBCR0VBIE9wZXJhdGluZyBTdXBwb3J0IGFuZCBSZXZlbnVlXG4gICAgICAgICAgICA8L1JldmVudWVIZWFkaW5nPlxuICAgICAgICAgICAgPGFcbiAgICAgICAgICAgICAgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL2Fib3V0L2ZpbmFuY2lhbC1pbmZvL1wiXG4gICAgICAgICAgICAgIHRpdGxlPVwiIEJpbGx5IEdyYWhhbSBGaW5hbmNpYWwgSW5mb1wiXG4gICAgICAgICAgICA+XG4gICAgICAgICAgICAgIDxpbWdcbiAgICAgICAgICAgICAgICBzcmM9XCJodHRwczovL3MzLnRoZWFyay5jbG91ZC9zdGF0aWMtYmlsbHlncmFoYW0tb3JnL3NpdGVzL2JpbGx5Z3JhaGFtLm9yZy91cGxvYWRzL3Byb2QvMjAyNS8wNC8yMDI0X29wZXJhdGluZ19zdXBwb3J0X3JldmVudWUucG5nXCJcbiAgICAgICAgICAgICAgICBhbHQ9XCJDb250cmlidXRpb25zLCA4OC42JTsgQmlsbHkgR3JhaGFtIFRyYWluaW5nIENlbnRlciwgNC41JTsgRGVjaXNpb24gTWFnYXppbmUgJiBvdGhlciBldmFuZ2VsaXN0aWMgbWF0ZXJpYWxzLCAxLjIlOyBPdGhlciBpbmNvbWUsIDUuNyUuXCJcbiAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgIDwvYT5cbiAgICAgICAgICA8L0NvbnRlbnQ+XG4gICAgICAgICAgPENvbnRlbnQ+XG4gICAgICAgICAgICA8UmV2ZW51ZUhlYWRpbmcgcmVuZGVyQXM9XCJoNFwiPlxuICAgICAgICAgICAgICAyMDI0IEJHRUEgT3BlcmF0aW5nIEV4cGVuc2VzXG4gICAgICAgICAgICA8L1JldmVudWVIZWFkaW5nPlxuICAgICAgICAgICAgPGFcbiAgICAgICAgICAgICAgaHJlZj1cImh0dHBzOi8vYmlsbHlncmFoYW0ub3JnL2Fib3V0L2ZpbmFuY2lhbC1pbmZvL1wiXG4gICAgICAgICAgICAgIHRpdGxlPVwiQmlsbHkgR3JhaGFtIEZpbmFuY2lhbCBJbmZvXCJcbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgPGltZ1xuICAgICAgICAgICAgICAgIHNyYz1cImh0dHBzOi8vczMudGhlYXJrLmNsb3VkL3N0YXRpYy1iaWxseWdyYWhhbS1vcmcvc2l0ZXMvYmlsbHlncmFoYW0ub3JnL3VwbG9hZHMvcHJvZC8yMDI1LzA0LzIwMjRfb3BlcmF0aW5nX2V4cGVuc2VzLnBuZ1wiXG4gICAgICAgICAgICAgICAgYWx0PVwiTWluaXN0cnkgZXhwZW5zZXMsIDg3LjIlOyBGdW5kcmFpc2luZywgNC41JTsgR2VuZXJhbCAmIEFkbWluaXN0cmF0aXZlLCA4LjMlLlwiXG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8L2E+XG4gICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgPC9Db2x1bW5zPlxuICAgIDwvRXhwZW5zZUNvbnRhaW5lcj5cbiAgKTtcbn07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
/**
 *  BGEA Expense data to be located at the bottom of a page above the footer
 *
 * ```js
 * import { ExpenseSupport } from '@bgea-js/design-library';
 * ```
 */
var ExpenseSupport = function ExpenseSupport(_ref) {
  var props = _extends$1({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  return jsx(ExpenseContainer, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: jsxs(Columns, {
      children: [jsxs(Columns.Column, {
        children: [jsx(H4$1, {
          renderAs: "h4",
          children: "Privacy Policy"
        }), jsxs(Content, {
          children: [jsxs("p", {
            children: ["By providing your personal details, you accept that we will use your personal details to communicate with you about ministry updates and opportunities from Billy Graham Evangelistic Association.", ' ', jsx(ContentLink, {
              href: "https://billygraham.org/privacy-policy/",
              children: "View our full Privacy Policy"
            }), "."]
          }), jsxs("p", {
            children: ["This form is for U.S. residents only. Canadian residents may give through the", ' ', jsx(ContentLink, {
              href: "https://secure.billygraham.ca/donate/",
              children: "BGEA Canada website"
            }), "."]
          }), jsx("p", {
            children: "All gifts designated for a specific project will be applied to the project with up to 10% used for administrative and fund-raising expenses. This is a secure form using industry standard SSL encryption technology."
          })]
        }), jsx(Content, {
          children: jsxs(Columns, {
            children: [jsx(Columns.Column, {
              children: jsx(Link$1, {
                target: "_blank",
                href: "https://billygraham.org/solicitation-disclosure-statement/",
                children: "Solicitation Disclosure Statement"
              })
            }), jsx(Columns.Column, {
              children: jsx(Link$1, {
                href: "https://billygraham.org/privacy-policy",
                children: "Privacy Policy"
              })
            })]
          })
        }), jsxs(Block, {
          children: [jsx(Visa, {}), jsx(MasterCard, {}), jsx(Amex, {}), jsx(Discovery, {}), jsx(Paypal, {}), jsx(ClearDiv, {})]
        })]
      }), jsxs(Columns.Column, {
        children: [jsx(H4$1, {
          renderAs: "h4",
          children: "Financial Accountability"
        }), jsxs(Content, {
          children: [jsx(RevenueHeading, {
            renderAs: "h4",
            children: "2024 BGEA Operating Support and Revenue"
          }), jsx("a", {
            href: "https://billygraham.org/about/financial-info/",
            title: " Billy Graham Financial Info",
            children: jsx("img", {
              src: "https://s3.theark.cloud/static-billygraham-org/sites/billygraham.org/uploads/prod/2025/04/2024_operating_support_revenue.png",
              alt: "Contributions, 88.6%; Billy Graham Training Center, 4.5%; Decision Magazine & other evangelistic materials, 1.2%; Other income, 5.7%."
            })
          })]
        }), jsxs(Content, {
          children: [jsx(RevenueHeading, {
            renderAs: "h4",
            children: "2024 BGEA Operating Expenses"
          }), jsx("a", {
            href: "https://billygraham.org/about/financial-info/",
            title: "Billy Graham Financial Info",
            children: jsx("img", {
              src: "https://s3.theark.cloud/static-billygraham-org/sites/billygraham.org/uploads/prod/2025/04/2024_operating_expenses.png",
              alt: "Ministry expenses, 87.2%; Fundraising, 4.5%; General & Administrative, 8.3%."
            })
          })]
        })]
      })]
    })
  }));
};

var footerLinks = [{
  label: 'Ministries',
  items: [{
    text: 'The Billy Graham Library',
    href: 'https://billygrahamlibrary.org/?_gl=1%2Amhw7ps%2A_gcl_au%2AODUyNzUxNjY2LjE2ODQ4NTAyNTY.&_ga=2.47996263.1936346106.1685959049-1517322228.1674071771'
  }, {
    text: 'Billy Graham Training Center at The Cove',
    href: 'https://thecove.org/?_gl=1%2a1p7m6lu%2a_gcl_au%2aODUyNzUxNjY2LjE2ODQ4NTAyNTY.&_ga=2.258422346.1936346106.1685959049-1517322228.1674071771'
  }, {
    text: 'Billy Graham Rapid Response Team',
    href: 'https://rrt.billygraham.org/?_gl=1%2A1un2t9m%2A_gcl_au%2AODUyNzUxNjY2LjE2ODQ4NTAyNTY.&_ga=2.160848381.1936346106.1685959049-1517322228.1674071771'
  }, {
    text: "Ruth's Attic Bookstore",
    href: 'https://www.billygrahambookstore.org/'
  }, {
    text: "SearchforJesus.net",
    href: 'https://searchforjesus.net/'
  }, {
    text: "PeaceWithGod.net",
    href: 'https://peacewithgod.net/'
  }]
}, {
  label: 'Social Media',
  items: [{
    text: 'Facebook',
    href: 'http://www.facebook.com/billygrahamevangelisticassociation'
  }, {
    text: 'Instagram',
    href: 'https://www.instagram.com/bgea/?hl=en'
  }, {
    text: 'Twitter',
    href: 'http://www.twitter.com/bgea'
  }, {
    text: 'YouTube',
    href: 'http://www.youtube.com/BillyGraham'
  }, {
    text: 'Pinterest',
    href: 'http://pinterest.com/bgea/'
  }]
}, {
  label: 'Legal',
  items: [{
    text: 'Privacy',
    href: 'https://billygraham.org/privacy-policy'
  }, {
    text: 'Permissions',
    href: 'https://billygraham.org/legal-permissions'
  }, {
    text: 'Solicitation',
    href: 'https://billygraham.org/solicitation-disclosure-statement/'
  }]
}];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Address = /*#__PURE__*/_styled("address", process.env.NODE_ENV === "production" ? {
  target: "e19t6jom5"
} : {
  target: "e19t6jom5",
  label: "Address"
})(process.env.NODE_ENV === "production" ? {
  name: "13u1z1e",
  styles: "font-style:normal"
} : {
  name: "13u1z1e",
  styles: "font-style:normal",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var FooterContainer = /*#__PURE__*/_styled(Footer$1, process.env.NODE_ENV === "production" ? {
  target: "e19t6jom4"
} : {
  target: "e19t6jom4",
  label: "FooterContainer"
})("font-size:0.875rem;letter-spacing:0;margin:0;padding:0;background-color:", colors.black, ";color:", colors.silver, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Section = /*#__PURE__*/_styled(Container, process.env.NODE_ENV === "production" ? {
  target: "e19t6jom3"
} : {
  target: "e19t6jom3",
  label: "Section"
})(process.env.NODE_ENV === "production" ? {
  name: "1s8ymgn",
  styles: "padding:1rem 1.5rem"
} : {
  name: "1s8ymgn",
  styles: "padding:1rem 1.5rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Divider = /*#__PURE__*/_styled("hr", process.env.NODE_ENV === "production" ? {
  target: "e19t6jom2"
} : {
  target: "e19t6jom2",
  label: "Divider"
})("border-top:1px solid ", colors.doveGray, ";height:1px;margin:0;padding:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var H4 = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "e19t6jom1"
} : {
  target: "e19t6jom1",
  label: "H4"
})("color:", colors.white, ";&.title.is-4{letter-spacing:0.094rem;margin-bottom:1rem;font-size:0.875rem;font-weight:bold;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Link = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e19t6jom0"
} : {
  target: "e19t6jom0",
  label: "Link"
})("font-size:0.875rem;letter-spacing:0;color:", colors.silver, ";text-decoration:none;font-weight:400;&:hover{color:", colors.silver, ";text-decoration:underline;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
/**
 * Standard BGEA footer to be located at the bottom of a page
 *
 * ```js
 * import { Footer } from '@bgea-js/design-library';
 * ```
 */
var Footer = function Footer(_ref) {
  var props = _extends$1({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var year = new Date().getFullYear();
  var fLinks = (props === null || props === void 0 ? void 0 : props.footerLinks) || footerLinks;
  var hasNewLogo = (props === null || props === void 0 ? void 0 : props.hasNewLogo) || false;
  return jsxs(FooterContainer, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: [jsx(Section, {
      children: jsxs(Columns, {
        py: 4,
        children: [jsx(Columns.Column, {
          children: jsx(Link, {
            href: "https://billygraham.org/",
            title: "Billy Graham Evangelistic Association",
            children: hasNewLogo ? jsx(BgeaNewIcon, {
              height: "85.276",
              width: "141.999",
              viewBox: "0 0 141.999 85.276"
            }) : jsx(BgeaIcon, {
              height: "3.75rem",
              width: "8.813rem",
              viewBox: "0 0 792 337"
            })
          })
        }), jsxs(Columns.Column, {
          children: [jsx(H4, {
            renderAs: "h4",
            size: 4,
            textTransform: "uppercase",
            children: "Contact"
          }), props !== null && props !== void 0 && props.contactUsContent ? jsx(Address, {
            dangerouslySetInnerHTML: {
              __html: props === null || props === void 0 ? void 0 : props.contactUsContent
            }
          }) : jsxs(Address, {
            children: ["Billy Graham Evangelistic Association ", jsx("br", {}), " 1 Billy Graham Parkway, ", jsx("br", {}), "Charlotte, NC 28201 ", jsx("br", {}), " Local: 704-401-2432 ", jsx("br", {}), " Toll-Free: 1-877-247-2426"]
          })]
        }), fLinks.map(function (link) {
          var _link$label, _link$label2;
          return jsxs(Columns.Column, {
            children: [jsx(H4, {
              renderAs: "h4",
              size: 4,
              textTransform: "uppercase",
              children: link.label
            }), jsx("ul", {
              children: link.items.map(function (item) {
                var _item$text;
                return jsx("li", {
                  children: jsx(Link, {
                    href: item.href,
                    children: item.text
                  })
                }, (_item$text = item.text) === null || _item$text === void 0 ? void 0 : _item$text.replace(' ', ''));
              })
            }, (_link$label2 = link.label) === null || _link$label2 === void 0 ? void 0 : _link$label2.replace(' ', ''))]
          }, (_link$label = link.label) === null || _link$label === void 0 ? void 0 : _link$label.replace(' ', ''));
        })]
      })
    }), jsx(Divider, {}), jsx(Section, {
      children: jsxs(Columns, {
        children: [jsxs(Columns.Column, {
          size: 10,
          children: ["\xA9".concat(year, " "), " BGEA is a registered 501(c)(3) non-profit organization."]
        }), jsx(Columns.Column, {
          size: 2,
          children: !(props !== null && props !== void 0 && props.hideContactUsLink) && jsx(Link, {
            href: (props === null || props === void 0 ? void 0 : props.contactUsUrl) || 'https://billygraham.org/about/contact',
            children: "Contact Us >"
          })
        })]
      })
    })]
  }));
};

// import * as colors from '@bgea-js/colors';

var HomePageCarouselContainer = /*#__PURE__*/_styled(Container, process.env.NODE_ENV === "production" ? {
  target: "e103uf850"
} : {
  target: "e103uf850",
  label: "HomePageCarouselContainer"
})("@import 'pure-react-carousel/dist/react-carousel.cjs.css';{}.carousel{.carousel__dots{padding:0 0.75rem;position:relative;.column{padding:0;padding-top:0;padding-bottom:0;margin:0;}button.carousel__dot{display:flex;border:none;padding:0;width:100%;height:100%;margin-top:5px;text-align:left;border-right:1px solid #707070;background-color:transparent;border-radius:0;padding-top:5px;span{color:#2a659f;}p{color:#707070;line-height:1.25;}&.carousel__dot--selected{border-top:5px solid #2a659f;padding-top:0;span{color:#707070;}p{color:#2a659f;}}}>.column:last-child button.carousel__dot{border-right:none;}}}", mediaQueries.forDesktopUp, "{.carousel{color:initial;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

// import { pickDomAttributes } from '@bgea-js/react-utilities';
// import { useRef } from 'react';
// import Slider from 'react-slick';
/* eslint import/no-unassigned-import: "off" */
// import './homePageCarousel.scss';
// import 'pure-react-carousel/dist/react-carousel.cjs.css';
var HomePageCarousel = function HomePageCarousel(_ref) {
  var _ref$content = _ref.content,
    content = _ref$content === void 0 ? [] : _ref$content,
    _ref$provider = _ref.provider,
    provider = _ref$provider === void 0 ? {
      naturalSlideWidth: 100,
      naturalSlideHeight: 100,
      totalSlides: content.length
    } : _ref$provider;
  return jsx(HomePageCarouselContainer, {
    children: jsxs(CarouselProvider, {
      naturalSlideWidth: provider.naturalSlideWidth,
      naturalSlideHeight: provider.naturalSlideHeight,
      isIntrinsicHeight: true,
      totalSlides: provider.totalSlides,
      children: [jsx(index$8, {
        children: content.map(function (item, i) {
          return jsx(index$7, {
            index: i,
            children: item.slide
          }, "HPCs");
        })
      }), jsx(Columns, {
        className: "carousel__dots",
        children: content.map(function (item, i) {
          return jsx(Columns.Column, {
            children: jsx(Dot$1, {
              slide: i,
              className: "is-hidden-mobile",
              children: jsx("div", {
                className: "px-2",
                children: item.nav
              })
            })
          }, "c");
        })
      })]
    })
  });
};

var BackgroundVideo = function BackgroundVideo(_ref) {
  var props = _extends$1({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  return jsxs("div", _objectSpread2$1(_objectSpread2$1({
    className: "backgroundArea"
  }, domAttributes), {}, {
    children: [jsx("div", {
      className: "background",
      children: jsxs("video", {
        className: "backgroundVideo",
        poster: "https://static.billygraham.org/sites/billygraham.org/uploads/prod/2023/05/230406_LR2_4833_web-712x475.jpg",
        autoPlay: true,
        loop: true,
        muted: true,
        width: "300",
        height: "150",
        children: [jsx("source", {
          src: "https://static.billygraham.org/sites/thecove.org/uploads/pro/2018/10/Cove+aerials-1080p_2.webm",
          type: "video/mp4",
          media: "all and (max-width:480px)"
        }), jsx("source", {
          src: "https://static.billygraham.org/sites/thecove.org/uploads/pro/2018/10/Cove+aerials-1080p_2.webm",
          type: "video/mp4",
          media: "all and (min-width:481px)"
        }), jsx("track", {})]
      })
    }), jsx("div", {
      className: "foreground",
      children: props.children
    })]
  }));
};
BackgroundVideo.propTypes = {
  content: PropTypes.any
};

var _excluded$4 = ["children"];
var BodyArticle = function BodyArticle(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties$1(_ref, _excluded$4);
  var domAttributes = pickDomAttributes(props);
  return jsx(Columns, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: jsx(Columns.Column, {
      offset: 2,
      size: 8,
      children: children
    })
  }));
};

var _excluded$3 = ["author", "intro", "children"];
var BodyDecisionArticle = function BodyDecisionArticle(_ref) {
  var author = _ref.author,
    intro = _ref.intro,
    children = _ref.children,
    props = _objectWithoutProperties$1(_ref, _excluded$3);
  var domAttributes = pickDomAttributes(props);
  return jsxs("div", _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: [jsx(Columns, {
      children: jsxs(Columns.Column, {
        size: 10,
        children: [jsx("div", {
          className: "is-size-1",
          style: {
            background: 'red',
            width: '100px',
            "float": 'left',
            color: '#fff',
            textAlign: 'center',
            borderRadius: '4rem',
            marginRight: '1rem'
          },
          children: "D"
        }), jsx("p", {
          children: intro
        }), jsx("hr", {})]
      })
    }), jsxs(Columns, {
      children: [jsxs(Columns.Column, {
        size: 2,
        children: [jsx("p", {
          children: "Written by"
        }), jsx("p", {
          children: author.name
        })]
      }), jsx(Columns.Column, {
        size: 8,
        children: jsx(Content$1, {
          children: children
        })
      })]
    })]
  }));
};

var _excluded$2 = ["prayer", "scripture", "image", "children"];
var BodyDevotion = function BodyDevotion(_ref) {
  var prayer = _ref.prayer,
    scripture = _ref.scripture,
    image = _ref.image,
    children = _ref.children,
    props = _objectWithoutProperties$1(_ref, _excluded$2);
  var domAttributes = pickDomAttributes(props);
  return jsxs(Columns, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: [jsxs(Columns.Column, {
      size: 8,
      children: [jsx("blockquote", {
        children: scripture.verse
      }), jsxs("cite", {
        children: ["\u2014", scripture.reference, scripture.translation && " (".concat(scripture.translation, ")")]
      }), jsx("hr", {}), jsxs(Columns, {
        children: [jsx(Columns.Column, {
          size: 2,
          children: jsx("time", {
            children: "AUG 02"
          })
        }), jsx(Columns.Column, {
          size: 10,
          children: jsx(Content$1, {
            children: children
          })
        })]
      })]
    }), jsx(Columns.Column, {
      size: 4,
      children: jsxs(Content$1, {
        children: [jsx("img", {
          src: image.src,
          alt: image.alt
        }), jsx("h3", {
          children: "PRAYER FOR THE DAY"
        }), jsx("p", {
          children: prayer
        })]
      })
    })]
  }));
};

var _excluded$1 = ["title", "subtitle", "author", "publishDate", "socialLinks", "ancestry"];
var HeaderArticle = function HeaderArticle(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    author = _ref.author,
    publishDate = _ref.publishDate,
    socialLinks = _ref.socialLinks,
    ancestry = _ref.ancestry,
    props = _objectWithoutProperties$1(_ref, _excluded$1);
  var domAttributes = pickDomAttributes(props);
  return jsx(Hero, _objectSpread2$1(_objectSpread2$1({
    gradient: true
  }, domAttributes), {}, {
    children: jsx(Hero.Body, {
      className: "p-0",
      children: jsxs(Container, {
        children: [title && jsx("h1", {
          className: "title",
          children: title
        }), subtitle && jsx("div", {
          className: "subtitle",
          children: subtitle
        }), jsxs(Columns, {
          className: "mb-0",
          children: [jsxs(Columns.Column, {
            children: [(author === null || author === void 0 ? void 0 : author.name) && jsxs("span", {
              className: "byline",
              children: ["By", ' ', author !== null && author !== void 0 && author.url ? jsx("a", {
                href: author.url,
                children: author.name
              }) : jsx(Fragment, {
                children: author.name
              })]
            }), author && publishDate && ' • ', publishDate && jsx("time", {
              className: "date",
              dateTime: publishDate.toLocaleString(),
              children: publishDate.toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })
            })]
          }), jsx(Columns.Column, {
            className: "is-narrow",
            children: socialLinks && jsxs("div", {
              children: [jsxs("a", {
                className: "button is-primary is-small",
                href: socialLinks.facebook,
                children: [jsx(FacebookIcon, {}), "Share"]
              }), ' ', jsxs("a", {
                className: "button is-primary is-small",
                href: socialLinks.twitter,
                children: [jsx(FacebookIcon, {}), "Tweet"]
              })]
            })
          })]
        }), jsx("hr", {
          className: "mt-0"
        }), ancestry && jsx(Breadcrumb, {
          separator: "succeeds",
          children: ancestry.map(function (page, i) {
            var active = i + 1 === ancestry.length;
            return jsx(Breadcrumb.Item, {
              active: active,
              children: jsx("a", {
                href: page.url,
                children: page.label
              })
            }, page.label);
          })
        })]
      })
    })
  }));
};

var HeroContainer = /*#__PURE__*/_styled(Hero, process.env.NODE_ENV === "production" ? {
  target: "egn6yj40"
} : {
  target: "egn6yj40",
  label: "HeroContainer"
})("background-color:", colors.stTropaz, ";color:", colors.white, ";img{display:block;}.title{font-size:28px;color:", colors.white, ";}.subtitle{color:", colors.white, ";font-size:18px;font-family:serif;}hr{height:1px;background-color:transparent;background-image:linear-gradient(\n      to right,\n      transparent 50%,\n      rgba(255, 255, 255, 1) 0%\n    );background-position:bottom;background-size:7px 1px;background-repeat:repeat-x;}", mediaQueries.forDesktopUp, "{hr{margin-left:-5rem;}.headerTextContent{padding-left:4rem;}.reverse-row{flex-direction:row-reverse;display:flex;hr{margin-right:-6.5rem;margin-left:0;}.headerTextContent{padding-right:4rem;padding-left:0;}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzhDIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBIZXJvIH0gZnJvbSAnQGJnZWEtanMvcmVhY3QtdWknO1xuaW1wb3J0IHsgbWVkaWFRdWVyaWVzIH0gZnJvbSAnQGJnZWEtanMvcmVhY3QtdXRpbGl0aWVzJztcbmltcG9ydCAqIGFzIGNvbG9ycyBmcm9tICdAYmdlYS1qcy9jb2xvcnMnO1xuXG5leHBvcnQgY29uc3QgSGVyb0NvbnRhaW5lciA9IHN0eWxlZChIZXJvKTxhbnk+YFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9ycy5zdFRyb3Bhen07XG4gIGNvbG9yOiAke2NvbG9ycy53aGl0ZX07XG4gIGltZyB7XG4gICAgLyogdGhpcyByZW1vdmVzIHRoZSBzcGFjZSBiZWxvdyB0aGUgaW1hZ2UgdGhhdCBwdXNoZXMgdGhlIGNvbnRhaW5lciBkb3duICovXG4gICAgZGlzcGxheTogYmxvY2s7XG4gIH1cblxuICAudGl0bGUge1xuICAgIGZvbnQtc2l6ZTogMjhweDtcbiAgICBjb2xvcjogJHtjb2xvcnMud2hpdGV9O1xuICB9XG5cbiAgLnN1YnRpdGxlIHtcbiAgICBjb2xvcjogJHtjb2xvcnMud2hpdGV9O1xuICAgIGZvbnQtc2l6ZTogMThweDtcbiAgICBmb250LWZhbWlseTogc2VyaWY7XG4gIH1cblxuICBociB7XG4gICAgaGVpZ2h0OiAxcHg7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYmFja2dyb3VuZC1pbWFnZTogbGluZWFyLWdyYWRpZW50KFxuICAgICAgdG8gcmlnaHQsXG4gICAgICB0cmFuc3BhcmVudCA1MCUsXG4gICAgICByZ2JhKDI1NSwgMjU1LCAyNTUsIDEpIDAlXG4gICAgKTtcbiAgICBiYWNrZ3JvdW5kLXBvc2l0aW9uOiBib3R0b207XG4gICAgYmFja2dyb3VuZC1zaXplOiA3cHggMXB4O1xuICAgIGJhY2tncm91bmQtcmVwZWF0OiByZXBlYXQteDtcbiAgfVxuXG4gICR7bWVkaWFRdWVyaWVzLmZvckRlc2t0b3BVcH0ge1xuICAgIGhyIHtcbiAgICAgIG1hcmdpbi1sZWZ0OiAtNXJlbTtcbiAgICB9XG4gICAgLmhlYWRlclRleHRDb250ZW50IHtcbiAgICAgIHBhZGRpbmctbGVmdDogNHJlbTtcbiAgICB9XG4gICAgLnJldmVyc2Utcm93IHtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiByb3ctcmV2ZXJzZTtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBociB7XG4gICAgICAgIG1hcmdpbi1yaWdodDogLTYuNXJlbTtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDA7XG4gICAgICB9XG4gICAgICAuaGVhZGVyVGV4dENvbnRlbnQge1xuICAgICAgICBwYWRkaW5nLXJpZ2h0OiA0cmVtO1xuICAgICAgICBwYWRkaW5nLWxlZnQ6IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG5gO1xuIl19 */"));

var _excluded = ["title", "subtitle", "reverse", "image", "imageWidth", "icon", "children"];
var HeaderPage = function HeaderPage(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    reverse = _ref.reverse,
    image = _ref.image,
    _ref$imageWidth = _ref.imageWidth,
    imageWidth = _ref$imageWidth === void 0 ? 'two-thirds' : _ref$imageWidth,
    icon = _ref.icon,
    children = _ref.children,
    props = _objectWithoutProperties$1(_ref, _excluded);
  var domAttributes = pickDomAttributes(props);
  var columnsClass = reverse ? 'reverse-row is-vcentered p-0' : 'is-vcentered p-0';
  return jsx(HeroContainer, _objectSpread2$1(_objectSpread2$1({}, domAttributes), {}, {
    children: jsx(Hero.Body, {
      className: "py-0",
      children: jsx(Container, {
        className: "",
        children: jsxs(Columns, {
          className: columnsClass,
          children: [image && jsx(Columns.Column, {
            desktop: {
              size: imageWidth
            },
            className: "px-0",
            children: jsx("img", {
              src: image.src,
              alt: image.alt
            })
          }), !image && children && jsx(Columns.Column, {
            desktop: {
              size: imageWidth
            },
            className: "px-0",
            children: children
          }), jsx(Columns.Column, {
            desktop: {
              size: 4
            },
            className: "pb-6",
            children: jsxs("div", {
              className: "headerTextContent",
              children: [jsx(Icon, {
                children: icon
              }), jsx("h1", {
                className: "title",
                children: title
              }), jsx("hr", {
                "aria-hidden": "true"
              }), jsx("span", {
                className: "subtitle",
                children: subtitle
              })]
            })
          })]
        })
      })
    })
  }));
};

// import * as colors from '@bgea-js/colors';

var TopContentContainer = /*#__PURE__*/_styled(Container, process.env.NODE_ENV === "production" ? {
  target: "e19zvc3u0"
} : {
  target: "e19zvc3u0",
  label: "TopContentContainer"
})(mediaQueries.forDesktopUp, "{.tier-2{.card{display:flex;flex-direction:row;padding-bottom:1rem;margin-bottom:1rem;border-bottom:1px solid #333;border-radius:0;.card-image{width:calc(40% - 1rem);padding-right:1rem;img{border-radius:0;}}.card-content{width:60%;padding-right:1rem;}p{display:none;}}a:last-child .card{border-bottom:none;}}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3lEIiwiZmlsZSI6InN0eWxlcy50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11aSc7XG5pbXBvcnQgeyBtZWRpYVF1ZXJpZXMgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11dGlsaXRpZXMnO1xuLy8gaW1wb3J0ICogYXMgY29sb3JzIGZyb20gJ0BiZ2VhLWpzL2NvbG9ycyc7XG5cbmV4cG9ydCBjb25zdCBUb3BDb250ZW50Q29udGFpbmVyID0gc3R5bGVkKENvbnRhaW5lcik8YW55PmBcbiAgJHttZWRpYVF1ZXJpZXMuZm9yRGVza3RvcFVwfSB7XG4gICAgLnRpZXItMiB7XG4gICAgICAuY2FyZCB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAgICAgIHBhZGRpbmctYm90dG9tOiAxcmVtO1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAxcmVtO1xuICAgICAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgIzMzMztcbiAgICAgICAgYm9yZGVyLXJhZGl1czogMDtcbiAgICAgICAgLmNhcmQtaW1hZ2Uge1xuICAgICAgICAgIHdpZHRoOiBjYWxjKDQwJSAtIDFyZW0pO1xuICAgICAgICAgIHBhZGRpbmctcmlnaHQ6IDFyZW07XG4gICAgICAgICAgaW1nIHtcbiAgICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDA7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICAgIC5jYXJkLWNvbnRlbnQge1xuICAgICAgICAgIHdpZHRoOiA2MCU7XG4gICAgICAgICAgcGFkZGluZy1yaWdodDogMXJlbTtcbiAgICAgICAgfVxuICAgICAgICBwIHtcbiAgICAgICAgICBkaXNwbGF5OiBub25lO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgICBhOmxhc3QtY2hpbGQgLmNhcmQge1xuICAgICAgICBib3JkZXItYm90dG9tOiBub25lO1xuICAgICAgfVxuICAgIH1cbiAgfVxuYDtcbiJdfQ== */"));

var TopContent = function TopContent(_ref) {
  var items = _ref.items;
  return jsx(TopContentContainer, {
    children: jsxs(Columns, {
      children: [jsx(Columns.Column, {
        size: 7,
        children: items.slice(0, 1).map(function (item) {
          return createElement(CardContent, _objectSpread2$1(_objectSpread2$1({}, item), {}, {
            key: item.title
          }));
        })
      }), jsx(Columns.Column, {
        className: "tier-2",
        children: items.slice(1, 5).map(function (item) {
          return createElement(CardContent, _objectSpread2$1(_objectSpread2$1({}, item), {}, {
            key: item.title
          }));
        })
      })]
    })
  });
};

export { AlertBanner, BackgroundVideo, BodyArticle, BodyDecisionArticle, BodyDevotion, ButtonCollapsible, Callout, CalloutImage, CardCTA, CardContent, Carousel, Collapsible, ContentCard, EchoChat, ExpenseSupport, Figure, Figures, Footer, HeaderArticle, HeaderPage, HomePageCarousel, ImageGallery, Kaltura, MobileMenu, NavbarGlobal, NavbarPrimary, NavbarSecondary, Promo, Promos, Tabs, TopContent, TwoColumns };
